import React, { useState, useEffect } from 'react';
import { openPrintWindow } from '../../utils/printDocument';
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  CardActions,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Alert,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
  InputAdornment,
  Tooltip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Checkbox
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Person as PersonIcon,
  Schedule as ScheduleIcon,
  Info as InfoIcon,
  Assignment as AssignmentIcon,
  FiberManualRecord as FiberManualRecordIcon,
  ExpandMore as ExpandMoreIcon,
  Close as CloseIcon,
  Save as SaveIcon,
  Print as PrintIcon,
  Search as SearchIcon,
  FilterList as FilterListIcon,
  Event as EventIcon,
  EventBusy as EventBusyIcon,
  PersonAdd as PersonAddIcon,
  ArrowBack as ArrowBackIcon,
  FileDownload as FileDownloadIcon,
  AccessTime as AccessTimeIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Business as BusinessIcon,
  CalendarToday as CalendarTodayIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Assessment as AssessmentIcon,
  EventNote as EventNoteIcon
} from '@mui/icons-material';
import { db, auth } from '../../firebase/config';
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  getDoc,
  serverTimestamp,
  setDoc,
  addDoc,
  onSnapshot,
  Timestamp
} from 'firebase/firestore';
import {
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
} from 'firebase/auth';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { updateUserEmail, isFirebaseAdminConfigured } from '../../services/firebaseAdmin';

const PersonnelManagement = () => {
  const { userData, currentUser } = useAuth();
  const navigate = useNavigate();
  const [establishmentInfo, setEstablishmentInfo] = useState(null);
  const services = [
    'ADMINISTRATIF',
    'TECHNIQUE',
    'DIRECTION',
    'LINGERIE',
    'ATELIER',
    'SERVICE_GENERAL',
    'CUISINE',
    'JARDIN',
    'SA'
  ];

  const formatService = (service) => {
    if (!service) return 'Service non spécifié';
    
    switch (service) {
      case 'SERVICE_GENERAL':
        return 'Service Général';
      case 'SA':
        return 'SA';
      default:
        return service.charAt(0) + service.slice(1).toLowerCase();
    }
  };

  const [personnel, setPersonnel] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [openAbsenceDialog, setOpenAbsenceDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [scheduleB, setScheduleB] = useState([]);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [editFormData, setEditFormData] = useState({
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    service: '',
    grade: '',
    status: 'actif',
    totalHours: '',
    hasAlternateSchedule: false, // Indique si le personnel a deux emplois du temps (A/B)
    schedule: {
      Lundi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Mardi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Mercredi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Jeudi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Vendredi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } }
    },
    scheduleB: { // Emploi du temps semaine B
      Lundi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Mardi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Mercredi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Jeudi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Vendredi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Samedi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } }
    }
  });
  const [addFormData, setAddFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    service: 'SERVICE_GENERAL',
    grade: '',
    role: 'personnel',
    status: 'actif',
    horaireDecale: false,
    observationHoraire: '',
    totalHours: '',
    hasAlternateSchedule: false, // Indique si le personnel a deux emplois du temps (A/B)
    schedule: {
      Lundi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Mardi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Mercredi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Jeudi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Vendredi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } }
    },
    scheduleB: { // Emploi du temps semaine B
      Lundi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Mardi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Mercredi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Jeudi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Vendredi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
      Samedi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } }
    }
  });
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [excelExportLoading, setExcelExportLoading] = useState(false);
  const [absenceFormData, setAbsenceFormData] = useState({
    dateDebut: new Date().toISOString().split('T')[0],
    dateFin: new Date().toISOString().split('T')[0],
    type: 'congé',
    autreType: '', // Type d'absence personnalisé quand type='autre'
    motif: '',
    statut: 'en attente',
    nature: 'demande', // 'demande' ou 'signalement'
    touteLaJournee: true, // Nouvelle propriété pour indiquer si c'est toute la journée
    nombreHeures: '', // Nouvelle propriété pour le nombre d'heures si pas toute la journée
    heureDebut: '08:00', // Heure de début de l'absence
    heureFin: '17:00', // Heure de fin de l'absence
    avecJustificatif: false // Nouvelle propriété pour indiquer si l'absence a un justificatif (arrêt maladie, etc.)
  });
  const [selectedPersonAbsences, setSelectedPersonAbsences] = useState([]);
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [selectedPersonInfo, setSelectedPersonInfo] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openAbsenceValidationDialog, setOpenAbsenceValidationDialog] = useState(false);
  const [selectedAbsenceForValidation, setSelectedAbsenceForValidation] = useState(null);
  const [validationComment, setValidationComment] = useState('');
  const [validationAction, setValidationAction] = useState('');

  // Fonction pour formater l'heure
  const formatTime = (timeString) => {
    if (!timeString) return '';
    return timeString;
  };

  // Fonction pour formater l'emploi du temps d'une journée
  const formatDaySchedule = (daySchedule) => {
    if (!daySchedule) return 'Non défini';
    
    if (!daySchedule.active) return 'Inactif';

    if (daySchedule.withBreak) {
      const morning = daySchedule.morning?.start && daySchedule.morning?.end
        ? `${formatTime(daySchedule.morning.start)} - ${formatTime(daySchedule.morning.end)}`
        : '';
      const afternoon = daySchedule.afternoon?.start && daySchedule.afternoon?.end
        ? `${formatTime(daySchedule.afternoon.start)} - ${formatTime(daySchedule.afternoon.end)}`
        : '';
      return `${morning ? 'Matin: ' + morning : ''}${morning && afternoon ? ' / ' : ''}${afternoon ? 'Après-midi: ' + afternoon : ''}`;
    } else {
      return daySchedule.continuous?.start && daySchedule.continuous?.end
        ? `${formatTime(daySchedule.continuous.start)} - ${formatTime(daySchedule.continuous.end)}`
        : 'Horaires non définis';
    }
  };

  const formatDaySchedulePrint = (schedule) => {
    if (!schedule) return 'Non défini';
    // Vérifier withBreak EN PREMIER — la coupure a la priorité sur le champ continuous
    if (schedule.withBreak) {
      const hasMorning = schedule.morning?.start && schedule.morning?.end;
      const hasAfternoon = schedule.afternoon?.start && schedule.afternoon?.end;
      if (hasMorning && hasAfternoon) {
        return `${schedule.morning.start} - ${schedule.morning.end}  |  Reprise: ${schedule.afternoon.start} - ${schedule.afternoon.end}`;
      }
      if (hasMorning) return `${schedule.morning.start} - ${schedule.morning.end}`;
      if (hasAfternoon) return `Reprise: ${schedule.afternoon.start} - ${schedule.afternoon.end}`;
    }
    // Horaire continu (withBreak = false)
    if (schedule.continuous?.start && schedule.continuous?.end) {
      return `${schedule.continuous.start} - ${schedule.continuous.end}`;
    }
    // Fallback : si morning/afternoon sont remplis sans withBreak (données legacy)
    if (schedule.morning?.start && schedule.morning?.end &&
        schedule.afternoon?.start && schedule.afternoon?.end) {
      return `${schedule.morning.start} - ${schedule.morning.end}  |  Reprise: ${schedule.afternoon.start} - ${schedule.afternoon.end}`;
    }
    return 'Horaires non définis';
  };

  // Fonction pour récupérer la liste du personnel
  const fetchPersonnel = async () => {
    setLoading(true);
    try {
      const user = auth.currentUser;
      if (!user) return;

      // Récupérer le personnel sous la responsabilité du chef de service
      const q = query(
        collection(db, 'users'),
        where('chefServiceId', '==', user.uid),
        where('role', '==', 'personnel')
      );

      const querySnapshot = await getDocs(q);
      const personnelData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      // Récupérer les informations du chef de service lui-même
      const chefServiceDoc = await getDoc(doc(db, 'users', user.uid));
      if (chefServiceDoc.exists()) {
        const chefServiceData = {
          id: user.uid,
          ...chefServiceDoc.data(),
          isCurrentUser: true // Marquer comme utilisateur actuel pour un affichage spécial si nécessaire
        };
        
        // Ajouter le chef de service à la liste du personnel
        personnelData.unshift(chefServiceData); // Ajouter en première position
      }

      setPersonnel(personnelData);
    } catch (error) {
      console.error('Erreur lors de la récupération du personnel:', error);
      setSnackbar({
        open: true,
        message: 'Erreur lors de la récupération du personnel',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPersonnel();
    fetchEstablishmentInfo();
  }, [userData]);

  const fetchEstablishmentInfo = async () => {
    if (userData?.establishmentId) {
      try {
        const establishmentDoc = await getDoc(doc(db, 'establishments', userData.establishmentId));
        if (establishmentDoc.exists()) {
          const data = establishmentDoc.data();
          setEstablishmentInfo(data);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des informations de l\'établissement:', error);
      }
    }
  };

  const handleEditClick = async (person) => {
    if (!person?.id) {
      setSnackbar({
        open: true,
        message: 'ID du personnel manquant',
        severity: 'error'
      });
      return;
    }

    try {
      setIsSubmitting(true);
      
      // Récupérer les données complètes de l'utilisateur depuis Firestore
      const userRef = doc(db, 'users', person.id);
      const userDoc = await getDoc(userRef);
      
      if (!userDoc.exists()) {
        setSnackbar({
          open: true,
          message: 'Utilisateur non trouvé',
          severity: 'error'
        });
        return;
      }
      
      const userData = userDoc.data();
      
      // Fusionner les données du planning si elles existent
      const defaultSchedule = {
        Lundi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
        Mardi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
        Mercredi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
        Jeudi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
        Vendredi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
        Samedi: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } },
        Dimanche: { active: false, tasks: [''], withBreak: false, continuous: { start: '', end: '' }, morning: { start: '', end: '' }, afternoon: { start: '', end: '' } }
      };
      
      const mergedSchedule = userData.schedule || defaultSchedule;
      const mergedScheduleB = userData.scheduleB || defaultSchedule;
      
      // Vérifier si c'est la propre fiche du chef de service
      const isCurrentUser = person.isCurrentUser || (auth.currentUser && person.id === auth.currentUser.uid);
      
      const formData = {
        id: person.id,
        firstName: userData.firstName || '',
        lastName: userData.lastName || '',
        email: userData.email || '',
        phone: userData.phone || '',
        service: userData.service || '',
        grade: userData.grade || '',
        role: userData.role || 'personnel',
        status: userData.status || 'actif',
        horaireDecale: userData.horaireDecale || false,
        observationHoraire: userData.observationHoraire || '',
        hasAlternateSchedule: userData.hasAlternateSchedule || false,
        totalHours: userData.totalHours || '',
        schedule: mergedSchedule,
        scheduleB: mergedScheduleB,
        isCurrentUser: isCurrentUser // Ajouter cette information pour l'utiliser dans le dialogue d'édition
      };

      setEditFormData(formData);
      setSelectedPerson({...person, isCurrentUser});
      setOpenEditDialog(true);

    } catch (error) {
      console.error('Erreur lors de l\'édition:', error);
      setSnackbar({
        open: true,
        message: `Erreur: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleScheduleChange = (day, field, value) => {
    setEditFormData(prevData => {
      const newSchedule = { ...prevData.schedule };
      
      // Gérer les champs imbriqués (morning.start, afternoon.end, etc.)
      if (field.includes('.')) {
        const [parent, child] = field.split('.');
        newSchedule[day] = {
          ...newSchedule[day],
          [parent]: {
            ...newSchedule[day][parent],
            [child]: value
          }
        };
      } else {
        newSchedule[day] = {
          ...newSchedule[day],
          [field]: value
        };
      }
      
      return {
        ...prevData,
        schedule: newSchedule
      };
    });
  };

  const handleScheduleChangeB = (day, field, value) => {
    setEditFormData(prevData => {
      const newScheduleB = { ...prevData.scheduleB };
      
      // Gérer les champs imbriqués (morning.start, afternoon.end, etc.)
      if (field.includes('.')) {
        const [parent, child] = field.split('.');
        newScheduleB[day] = {
          ...newScheduleB[day],
          [parent]: {
            ...newScheduleB[day][parent],
            [child]: value
          }
        };
      } else {
        newScheduleB[day] = {
          ...newScheduleB[day],
          [field]: value
        };
      }
      
      return {
        ...prevData,
        scheduleB: newScheduleB
      };
    });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!editFormData?.id) {
      setSnackbar({
        open: true,
        message: 'ID du personnel manquant',
        severity: 'error'
      });
      return;
    }

    try {
      setIsSubmitting(true);
      
      const userRef = doc(db, 'users', editFormData.id);
      const userDoc = await getDoc(userRef);
      
      if (!userDoc.exists()) {
        throw new Error('Document utilisateur non trouvé');
      }

      const userData = userDoc.data();
      
      // Calculer le total des heures hebdomadaires
      const totalHours = calculateTotalHours(editFormData.schedule);

      // Si c'est la propre fiche du chef de service, préserver certaines valeurs
      const isCurrentUser = editFormData.isCurrentUser || (auth.currentUser && editFormData.id === auth.currentUser.uid);
      
      const updateData = {
        firstName: editFormData.firstName,
        lastName: editFormData.lastName,
        email: editFormData.email,
        phone: editFormData.phone,
        // Préserver le service et le rôle si c'est la propre fiche du chef de service
        service: isCurrentUser ? userData.service : (editFormData.service || 'SERVICE_GENERAL'),
        grade: editFormData.grade,
        horaireDecale: editFormData.horaireDecale || false,
        observationHoraire: editFormData.horaireDecale ? (editFormData.observationHoraire || '') : '',
        hasAlternateSchedule: editFormData.hasAlternateSchedule || false,
        schedule: editFormData.schedule,
        scheduleB: editFormData.hasAlternateSchedule ? editFormData.scheduleB : null,
        totalHours: totalHours, // Ajouter le total des heures hebdomadaires
        updatedAt: serverTimestamp()
      };

      // Ne pas modifier le statut si c'est la propre fiche du chef de service
      if (!isCurrentUser && editFormData.status) {
        updateData.status = editFormData.status;
      }

      // Vérifier si l'email a changé et si Firebase Admin est configuré
      const emailChanged = editFormData.email !== userData.email;
      let firebaseAuthUpdateSuccess = false;
      
      if (emailChanged) {
        
        if (isFirebaseAdminConfigured()) {
          try {
            const result = await updateUserEmail(editFormData.id, editFormData.email);
            if (result.success) {
              firebaseAuthUpdateSuccess = true;
              setSnackbar({
                open: true,
                message: 'Email mis à jour dans Firebase Auth',
                severity: 'info'
              });
            } else {
              console.error('Erreur Firebase Auth:', result.error);
              setSnackbar({
                open: true,
                message: `Erreur Firebase Auth: ${result.error}`,
                severity: 'warning'
              });
              // Continuer avec la mise à jour Firestore même si Firebase Auth échoue
            }
          } catch (error) {
            console.error('Erreur lors de la mise à jour Firebase Auth:', error);
            setSnackbar({
              open: true,
              message: 'Erreur lors de la mise à jour Firebase Auth',
              severity: 'warning'
            });
            // Continuer avec la mise à jour Firestore même si Firebase Auth échoue
          }
        } else {
          console.warn('Firebase Admin non configuré, email non mis à jour dans Firebase Auth');
          setSnackbar({
            open: true,
            message: '⚠️ Firebase Admin non configuré. Email mis à jour uniquement dans la base de données.',
            severity: 'warning'
          });
        }
      }

      await updateDoc(userRef, updateData);

      setOpenEditDialog(false);
      
      // Message de succès approprié
      let successMessage = 'Personnel modifié avec succès';
      if (emailChanged && firebaseAuthUpdateSuccess) {
        successMessage = 'Personnel modifié avec succès (y compris dans Firebase Auth)';
      } else if (emailChanged) {
        successMessage = 'Personnel modifié avec succès (email mis à jour uniquement en base de données)';
      }
      
      setSnackbar({
        open: true,
        message: successMessage,
        severity: 'success'
      });
      fetchPersonnel(); // Rafraîchir la liste
    } catch (error) {
      setSnackbar({
        open: true,
        message: `Erreur lors de la modification: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTaskChange = (day, index, value) => {
    setEditFormData(prevData => {
      const newSchedule = { ...prevData.schedule };
      const newTasks = [...newSchedule[day].tasks];
      newTasks[index] = value;
      
      newSchedule[day] = {
        ...newSchedule[day],
        tasks: newTasks
      };
      
      return {
        ...prevData,
        schedule: newSchedule
      };
    });
  };

  const handleAddTask = (day) => {
    setEditFormData(prevData => {
      const newSchedule = { ...prevData.schedule };
      newSchedule[day] = {
        ...newSchedule[day],
        tasks: [...(newSchedule[day].tasks || []), '']
      };
      
      return {
        ...prevData,
        schedule: newSchedule
      };
    });
  };

  const handleRemoveTask = (day, index) => {
    setEditFormData(prevData => {
      const newSchedule = { ...prevData.schedule };
      const newTasks = newSchedule[day].tasks.filter((_, i) => i !== index);
      
      newSchedule[day] = {
        ...newSchedule[day],
        tasks: newTasks
      };
      
      return {
        ...prevData,
        schedule: newSchedule
      };
    });
  };

  const handleTaskChangeB = (day, index, value) => {
    setEditFormData(prevData => {
      const newScheduleB = { ...prevData.scheduleB };
      const newTasks = [...(newScheduleB[day]?.tasks || [])];
      newTasks[index] = value;
      
      newScheduleB[day] = {
        ...newScheduleB[day],
        tasks: newTasks
      };
      
      return {
        ...prevData,
        scheduleB: newScheduleB
      };
    });
  };

  const handleAddTaskB = (day) => {
    setEditFormData(prevData => {
      const newScheduleB = { ...prevData.scheduleB };
      newScheduleB[day] = {
        ...newScheduleB[day],
        tasks: [...(newScheduleB[day]?.tasks || []), '']
      };
      
      return {
        ...prevData,
        scheduleB: newScheduleB
      };
    });
  };

  const handleRemoveTaskB = (day, index) => {
    setEditFormData(prevData => {
      const newScheduleB = { ...prevData.scheduleB };
      const newTasks = newScheduleB[day]?.tasks?.filter((_, i) => i !== index) || [];
      
      newScheduleB[day] = {
        ...newScheduleB[day],
        tasks: newTasks
      };
      
      return {
        ...prevData,
        scheduleB: newScheduleB
      };
    });
  };

  const handleDelete = async (personId) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce membre du personnel ?')) {
      return;
    }

    try {
      await deleteDoc(doc(db, 'users', personId));
      setSnackbar({
        open: true,
        message: 'Personnel supprimé avec succès',
        severity: 'success'
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Erreur lors de la suppression',
        severity: 'error'
      });
    }
  };

  const handleAbsenceClick = (person) => {
    setSelectedPerson(person);
    setOpenAbsenceDialog(true);
  };

  const handleCloseAbsenceDialog = () => {
    setOpenAbsenceDialog(false);
    setSelectedPerson(null);
    // Réinitialiser le formulaire d'absence
    setAbsenceFormData({
      dateDebut: new Date().toISOString().split('T')[0],
      dateFin: new Date().toISOString().split('T')[0],
      type: 'congé',
      autreType: '',
      motif: '',
      statut: 'en attente',
      nature: 'demande',
      touteLaJournee: true,
      nombreHeures: '',
      heureDebut: '08:00',
      heureFin: '17:00',
      avecJustificatif: false
    });
  };

  const fetchPersonAbsences = async (personId) => {
    try {
      const absencesRef = collection(db, 'absences');
      const q = query(absencesRef, where('personnelId', '==', personId));
      const querySnapshot = await getDocs(q);
      const absences = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setSelectedPersonAbsences(absences);
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Erreur lors de la récupération des absences",
        severity: 'error'
      });
    }
  };

  const handleValidateAbsence = async (absence, action) => {
    setSelectedAbsenceForValidation(absence);
    setValidationAction(action);
    setOpenAbsenceValidationDialog(true);
  };

  const submitAbsenceValidation = async () => {
    if (!selectedAbsenceForValidation) return;

    try {
      const newStatus = validationAction === 'approve' ? 'approuvée' : 'refusée';
      
      await updateDoc(doc(db, 'absences', selectedAbsenceForValidation.id), {
        statut: newStatus,
        validatedBy: currentUser.uid,
        validatedAt: serverTimestamp(),
        validationComment: validationComment || null,
        updatedAt: serverTimestamp()
      });

      setSnackbar({
        open: true,
        message: `Absence ${newStatus} avec succès`,
        severity: 'success'
      });

      setOpenAbsenceValidationDialog(false);
      setValidationComment('');
      
      // Recharger les absences de la personne
      if (selectedPerson) {
        await fetchPersonAbsences(selectedPerson.id);
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Erreur lors de la validation',
        severity: 'error'
      });
    }
  };

  const calculateTotalAbsenceDays = (absences) => {
    let totalDays = 0;
    absences.forEach(absence => {
      const start = new Date(absence.dateDebut);
      const end = new Date(absence.dateFin);
      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 pour inclure le jour de début
      totalDays += diffDays;
    });
    return totalDays;
  };

  const handleDetailsClick = async (person) => {
    setSelectedPerson(person);
    setOpenDetailsDialog(true);
    setLoadingDetails(true);
    await Promise.all([
      fetchPersonAbsences(person.id),
      fetchPersonSchedule(person.id)
    ]);
    setLoadingDetails(false);
  };

  const handleCloseDetailsDialog = () => {
    setOpenDetailsDialog(false);
    setSelectedPerson(null);
    setTasks([]);
    setSchedule([]);
    setScheduleB([]);
  };

  const handlePrint = (person) => {
    // Créer le contenu à imprimer
    const weeklyHours = calculateWeeklyHours(person.schedule);
    // Si la personne a un emploi du temps alterné, calculer aussi les heures de la semaine B
    const weeklyHoursB = person.hasAlternateSchedule && person.scheduleB ? calculateWeeklyHours(person.scheduleB) : 0;
    const orderedDays = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
    // Génère le HTML d'un tableau d'emploi du temps
    const scheduleTableHtml = (scheduleData, label) => `
      ${label ? `<div class="week-label">${label}</div>` : ''}
      <table class="schedule-table">
        <thead>
          <tr><th>Jour</th><th>Horaire</th><th>Tâches</th></tr>
        </thead>
        <tbody>
          ${orderedDays.map(day => {
            const s = scheduleData?.[day] || { active: false, tasks: [] };
            const horaire = s.active ? formatDaySchedulePrint(s) : '<span class="inactive">Inactif</span>';
            const coupureBadge = s.active && s.withBreak
              ? '<span class="badge-coupure">COUPURE</span>' : '';
            const rowClass = s.active && s.withBreak ? 'row-coupure' : '';
            return `<tr class="${rowClass}">
              <td class="day-cell">${day}</td>
              <td>${horaire}${coupureBadge}</td>
              <td>${s.tasks?.filter(t => t).join(', ') || '—'}</td>
            </tr>`;
          }).join('')}
        </tbody>
      </table>
      <div class="total-hours">
        Total : <strong>${scheduleData === person.schedule ? weeklyHours : weeklyHoursB} h / semaine</strong>
        ${person.horaireDecale ? ' &nbsp;•&nbsp; <span style="color:#c0392b;font-weight:700;">Horaire décalé</span>' : ''}
        ${person.horaireDecale && person.observationHoraire ? `<br><em style="font-weight:400;">${person.observationHoraire}</em>` : ''}
      </div>`;

    const extraCss = `
            /* Chaque .print-page occupe exactement une feuille A4 (fige hauteur
               pour empêcher le débordement même en multi-page) */
            .print-page {
              height: 297mm;
              overflow: hidden;
              font-size: 12px;
              justify-content: space-between;
            }

            /* ── En-tête ── */
            .doc-header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              border-bottom: 2.5px solid #0f4c5c;
              padding-bottom: 10px;
            }
            .school-name { font-size: 16px; font-weight: 700; color: #0f4c5c; }
            .school-sub  { font-size: 11px; color: #4a5568; margin-top: 4px; }
            .doc-title   { font-size: 17px; font-weight: 700; color: #0f4c5c; text-align: right; }
            .doc-subtitle { font-size: 11px; color: #4a5568; text-align: right; margin-top: 3px; }

            /* ── Info personnelles ── */
            .info-grid {
              display: grid;
              grid-template-columns: 1fr 1fr 1fr;
              gap: 6px 20px;
              background: #f0f4f8;
              padding: 12px 14px;
              border-radius: 6px;
              font-size: 11.5px;
            }
            .info-grid .lbl { color: #4a5568; }
            .info-grid strong { color: #0f4c5c; }

            /* ── Section titre ── */
            .section-title {
              font-size: 11.5px;
              font-weight: 700;
              color: #0f4c5c;
              text-transform: uppercase;
              letter-spacing: 0.06em;
              padding-bottom: 5px;
              border-bottom: 1px solid #d0dce5;
            }

            /* ── Tableau emploi du temps ── */
            .schedule-table {
              width: 100%;
              border-collapse: collapse;
              font-size: 11.5px;
            }
            .schedule-table thead th {
              background: #0f4c5c;
              color: #fff;
              padding: 8px 12px;
              text-align: left;
              font-size: 10.5px;
              text-transform: uppercase;
              letter-spacing: 0.06em;
            }
            .schedule-table tbody td {
              padding: 9px 12px;
              border-bottom: 1px solid #e2e8f0;
              vertical-align: middle;
              line-height: 1.4;
            }
            .schedule-table tbody tr:last-child td { border-bottom: none; }
            .row-coupure { background: #fff8e1; }
            .day-cell { font-weight: 700; width: 11%; }
            .inactive { color: #aaa; }
            .badge-coupure {
              display: inline-block;
              margin-left: 7px;
              padding: 2px 7px;
              background: #f59e0b;
              color: #fff;
              border-radius: 4px;
              font-size: 9px;
              font-weight: 700;
              vertical-align: middle;
            }

            /* ── Total heures ── */
            .total-hours {
              font-size: 11.5px;
              padding: 9px 14px;
              background: #f0f4f8;
              border-radius: 5px;
            }

            /* ── Signatures ── */
            .signatures {
              display: flex;
              justify-content: space-between;
              border-top: 2px solid #0f4c5c;
              padding-top: 10px;
            }
            .sig-box {
              width: 30%;
              text-align: center;
              font-size: 11px;
            }
            .sig-line {
              margin-top: 45mm;
              border-top: 1px solid #555;
              padding-top: 5px;
              font-weight: 700;
              font-size: 11.5px;
            }
            .sig-date { margin-top: 6px; font-style: italic; color: #555; font-size: 10.5px; }

            /* ── Saut de page pour semaines alternées ── */
            .page-break { page-break-before: always; }
    `;

    const bodyHtml = `
          <!-- PAGE 1 -->
          <div class="print-page">
            <div class="doc-header">
              <div>
                <div class="school-name">${establishmentInfo?.name || 'Établissement scolaire'}</div>
                <div class="school-sub">${[establishmentInfo?.academie ? 'Académie : ' + establishmentInfo.academie : '', establishmentInfo?.anneeScolaire ? 'Année : ' + establishmentInfo.anneeScolaire : ''].filter(Boolean).join('  •  ')}</div>
              </div>
              <div>
                <div class="doc-title">Fiche de Personnel</div>
                <div class="doc-subtitle">Imprimé le ${new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })}</div>
              </div>
            </div>

            <div class="info-grid">
              <div><span class="lbl">Nom &amp; Prénom : </span><strong>${person.firstName} ${person.lastName}</strong></div>
              <div><span class="lbl">Service : </span><strong>${formatService(person.service)}</strong></div>
              <div><span class="lbl">Grade : </span><strong>${person.grade || '—'}</strong></div>
              <div><span class="lbl">Email : </span>${person.email}</div>
              <div><span class="lbl">Téléphone : </span>${person.phone || '—'}</div>
              <div><span class="lbl">Statut : </span><strong>${person.status === 'actif' ? 'Actif' : 'Inactif'}</strong></div>
            </div>

            <div class="section-title">${person.hasAlternateSchedule ? 'Emploi du temps — Semaines alternées' : 'Emploi du temps'}</div>

            ${!person.hasAlternateSchedule
              ? scheduleTableHtml(person.schedule, null)
              : scheduleTableHtml(person.schedule, 'Semaine A')
            }

            <div class="signatures">
              <div class="sig-box">
                <div>Signature de l'agent</div>
                <div class="sig-line">${person.firstName} ${person.lastName}</div>
                <div class="sig-date">Date : _______________</div>
              </div>
              <div class="sig-box">
                <div>Chef d'établissement</div>
                <div class="sig-line">${establishmentInfo?.directorName || '—'}</div>
                <div class="sig-date">Date : _______________</div>
              </div>
              <div class="sig-box">
                <div>Chef de service</div>
                <div class="sig-line">${(userData?.firstName || '') + ' ' + (userData?.lastName || '')}</div>
                <div class="sig-date">Date : _______________</div>
              </div>
            </div>
          </div>

          ${person.hasAlternateSchedule ? `
          <!-- PAGE 2 — Semaine B -->
          <div class="print-page page-break">
            <div class="doc-header">
              <div>
                <div class="school-name">${establishmentInfo?.name || 'Établissement scolaire'}</div>
                <div class="school-sub">${[establishmentInfo?.academie ? 'Académie : ' + establishmentInfo.academie : '', establishmentInfo?.anneeScolaire ? 'Année : ' + establishmentInfo.anneeScolaire : ''].filter(Boolean).join('  •  ')}</div>
              </div>
              <div>
                <div class="doc-title">Fiche de Personnel — Suite</div>
                <div class="doc-subtitle">${person.firstName} ${person.lastName}</div>
              </div>
            </div>
            <div class="section-title">Emploi du temps — Semaine B</div>
            ${scheduleTableHtml(person.scheduleB, null)}
            <div class="signatures">
              <div class="sig-box">
                <div>Signature de l'agent</div>
                <div class="sig-line">${person.firstName} ${person.lastName}</div>
                <div class="sig-date">Date : _______________</div>
              </div>
              <div class="sig-box">
                <div>Chef d'établissement</div>
                <div class="sig-line">${establishmentInfo?.directorName || '—'}</div>
                <div class="sig-date">Date : _______________</div>
              </div>
              <div class="sig-box">
                <div>Chef de service</div>
                <div class="sig-line">${(userData?.firstName || '') + ' ' + (userData?.lastName || '')}</div>
                <div class="sig-date">Date : _______________</div>
              </div>
            </div>
          </div>` : ''}`;

    openPrintWindow(
      `Fiche Personnel — ${person.firstName} ${person.lastName}`,
      bodyHtml,
      extraCss,
      'height=900,width=1000',
      { singlePage: false }
    );
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Récupérer l'ID du chef de service connecté
      const currentUser = auth.currentUser;
      
      // Vérifier que nous avons l'establishmentId du chef de service
      if (!userData || !userData.establishmentId) {
        throw new Error("Données de l'établissement non disponibles");
      }
      
      // Créer l'utilisateur dans Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        addFormData.email,
        addFormData.password
      );
      const newUser = userCredential.user;
      
      const now = serverTimestamp();

      // Préparer les données utilisateur
      const newUserData = {
        uid: newUser.uid,
        firstName: addFormData.firstName,
        lastName: addFormData.lastName,
        email: addFormData.email,
        phone: addFormData.phone,
        service: addFormData.service || 'SERVICE_GENERAL',
        grade: addFormData.grade,
        role: 'personnel',
        status: 'actif',
        horaireDecale: addFormData.horaireDecale || false,
        observationHoraire: addFormData.horaireDecale ? (addFormData.observationHoraire || '') : '',
        totalHours: calculateTotalHours(addFormData.schedule),
        hasAlternateSchedule: addFormData.hasAlternateSchedule || false,
        schedule: addFormData.schedule,
        scheduleB: addFormData.hasAlternateSchedule ? addFormData.scheduleB : null,
        establishmentId: userData.establishmentId, // Utiliser l'establishmentId du chef de service
        chefServiceId: currentUser.uid,
        createdBy: currentUser.uid,
        createdAt: now,
        updatedAt: now
      };
      
      // Créer le document utilisateur dans Firestore
      const userRef = doc(db, 'users', newUser.uid);
      await setDoc(userRef, newUserData);

      // Envoyer un email de réinitialisation de mot de passe
      await sendPasswordResetEmail(auth, addFormData.email);

      setOpenAddDialog(false);
      setSnackbar({
        open: true,
        message: 'Membre ajouté avec succès. Un email de réinitialisation de mot de passe a été envoyé.',
        severity: 'success'
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Erreur lors de l\'ajout du membre: ' + error.message,
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false
    });
  };

  // Fonction pour exporter les données du personnel en Excel
  const handleExportToExcel = () => {
    setExcelExportLoading(true);
    try {
      // Préparer les données pour l'export
      const exportData = filteredPersonnel.map(person => {
        // Calculer le total d'heures hebdomadaires
        const totalHours = calculateTotalHours(person.schedule);
        
        // Formater l'emploi du temps pour l'export Excel
        const formattedSchedule = {};
        if (person.schedule) {
          Object.entries(person.schedule).forEach(([day, daySchedule]) => {
            if (daySchedule.active) {
              if (daySchedule.withBreak) {
                formattedSchedule[`${day}_Matin`] = `${daySchedule.morning?.start || ''} - ${daySchedule.morning?.end || ''}`;
                formattedSchedule[`${day}_Après-midi`] = `${daySchedule.afternoon?.start || ''} - ${daySchedule.afternoon?.end || ''}`;
              } else {
                formattedSchedule[day] = `${daySchedule.continuous?.start || ''} - ${daySchedule.continuous?.end || ''}`;
              }
              
              // Ajouter les tâches
              if (daySchedule.tasks && daySchedule.tasks.length > 0 && daySchedule.tasks[0] !== '') {
                formattedSchedule[`${day}_Tâches`] = daySchedule.tasks.join(', ');
              }
            } else {
              formattedSchedule[day] = 'Non travaillé';
            }
          });
        }
        
        // Retourner l'objet formaté pour Excel
        return {
          'Nom': person.lastName,
          'Prénom': person.firstName,
          'Email': person.email,
          'Téléphone': person.phone || 'Non renseigné',
          'Service': formatService(person.service),
          'Grade': person.grade || 'Non renseigné',
          'Statut': person.status === 'actif' ? 'Actif' : 'Inactif',
          'Heures Hebdomadaires': totalHours,
          ...formattedSchedule
        };
      });
      
      // Créer un classeur Excel
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Personnel');
      
      // Générer le fichier Excel
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      // Télécharger le fichier
      const fileName = `personnel_${userData?.service || 'service'}_${new Date().toISOString().split('T')[0]}.xlsx`;
      const url = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      
      // Nettoyer
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        setExcelExportLoading(false);
        showSnackbar('Export Excel réussi', 'success');
      }, 100);
    } catch (error) {
      console.error('Erreur lors de l\'export Excel:', error);
      setExcelExportLoading(false);
      showSnackbar('Erreur lors de l\'export Excel', 'error');
    }
  };

  const filteredPersonnel = personnel.filter(person =>
    `${person.firstName} ${person.lastName}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
    person.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (person.service || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleTimeChange = (day, period, field, value) => {
    setAddFormData(prev => ({
      ...prev,
      schedule: {
        ...prev.schedule,
        [day]: {
          ...prev.schedule[day],
          [period]: {
            ...prev.schedule[day][period],
            [field]: value
          }
        }
      }
    }));
  };
  
  // Fonction pour gérer les changements d'horaires dans la semaine B
  const handleTimeChangeB = (day, period, field, value) => {
    setAddFormData(prev => ({
      ...prev,
      scheduleB: {
        ...prev.scheduleB,
        [day]: {
          ...prev.scheduleB[day],
          [period]: {
            ...prev.scheduleB[day][period],
            [field]: value
          }
        }
      }
    }));
  };

  // Fonction pour calculer le total des heures
  const calculateTotalHours = (schedule) => {
    let totalMinutes = 0;
    
    Object.values(schedule).forEach(day => {
      if (day.active) {
        if (day.withBreak) {
          // Calculer les heures du matin
          if (day.morning.start && day.morning.end) {
            const [startHour, startMin] = day.morning.start.split(':').map(Number);
            const [endHour, endMin] = day.morning.end.split(':').map(Number);
            totalMinutes += (endHour * 60 + endMin) - (startHour * 60 + startMin);
          }
          // Calculer les heures de l'après-midi
          if (day.afternoon.start && day.afternoon.end) {
            const [startHour, startMin] = day.afternoon.start.split(':').map(Number);
            const [endHour, endMin] = day.afternoon.end.split(':').map(Number);
            totalMinutes += (endHour * 60 + endMin) - (startHour * 60 + startMin);
          }
        } else {
          // Calculer les heures en continu
          if (day.continuous.start && day.continuous.end) {
            const [startHour, startMin] = day.continuous.start.split(':').map(Number);
            const [endHour, endMin] = day.continuous.end.split(':').map(Number);
            totalMinutes += (endHour * 60 + endMin) - (startHour * 60 + startMin);
          }
        }
      }
    });

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h${minutes.toString().padStart(2, '0')}`;
  };

  const formatDateToTimestamp = (dateString) => {
    if (!dateString) return null;
    const [year, month, day] = dateString.split('-').map(Number);
    return Timestamp.fromDate(new Date(year, month - 1, day));
  };

  const handleAbsenceSubmit = async (e, nature) => {
    e.preventDefault();
    try {

      if (!absenceFormData.dateDebut || !absenceFormData.dateFin) {
        throw new Error('Les dates de début et de fin sont requises');
      }

      // Vérification du format YYYY-MM-DD
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(absenceFormData.dateDebut) || !dateRegex.test(absenceFormData.dateFin)) {
        throw new Error('Format de date invalide. Utilisez le format YYYY-MM-DD');
      }

      // Conversion en Date pour comparaison
      const dateDebut = new Date(absenceFormData.dateDebut);
      const dateFin = new Date(absenceFormData.dateFin);


      if (isNaN(dateDebut.getTime()) || isNaN(dateFin.getTime())) {
        throw new Error('Les dates saisies sont invalides');
      }

      if (dateFin < dateDebut) {
        throw new Error('La date de fin doit être postérieure ou égale à la date de début');
      }

      // Validation du nombre d'heures et des heures si ce n'est pas toute la journée
      if (!absenceFormData.touteLaJournee) {
        if (!absenceFormData.nombreHeures || absenceFormData.nombreHeures <= 0) {
          throw new Error('Le nombre d\'heures est requis si l\'absence n\'est pas pour toute la journée');
        }
        if (absenceFormData.nombreHeures > 24) {
          throw new Error('Le nombre d\'heures ne peut pas dépasser 24 heures');
        }
        
        // Validation des heures de début et fin
        if (!absenceFormData.heureDebut || !absenceFormData.heureFin) {
          throw new Error('Les heures de début et de fin sont requises pour une absence partielle');
        }
        
        // Vérifier que l'heure de fin est après l'heure de début
        const heureDebut = new Date(`2000-01-01T${absenceFormData.heureDebut}:00`);
        const heureFin = new Date(`2000-01-01T${absenceFormData.heureFin}:00`);
        
        if (heureFin <= heureDebut) {
          throw new Error('L\'heure de fin doit être postérieure à l\'heure de début');
        }
      }

      // Conversion en Timestamp Firestore
      const debutTimestamp = formatDateToTimestamp(absenceFormData.dateDebut);
      const finTimestamp = formatDateToTimestamp(absenceFormData.dateFin);

      if (!debutTimestamp || !finTimestamp) {
        throw new Error('Erreur lors de la conversion des dates');
      }

      const absenceData = {
        personnelId: selectedPerson.id,
        chefServiceId: currentUser.uid,
        dateDebut: debutTimestamp,
        dateFin: finTimestamp,
        type: absenceFormData.type,
        autreType: absenceFormData.type === 'autre' ? absenceFormData.autreType : null,
        motif: absenceFormData.motif,
        statut: nature === 'signalement' ? 'signalée' : 'en attente',
        nature: nature,
        nomPersonnel: selectedPerson.lastName,
        prenomPersonnel: selectedPerson.firstName,
        nomComplet: `${selectedPerson.firstName} ${selectedPerson.lastName}`,
        createdAt: serverTimestamp(),
        service: selectedPerson.service || userData.service,
        establishmentId: userData.establishmentId,
        touteLaJournee: absenceFormData.touteLaJournee,
        nombreHeures: absenceFormData.touteLaJournee ? null : absenceFormData.nombreHeures,
        heureDebut: absenceFormData.touteLaJournee ? null : absenceFormData.heureDebut,
        heureFin: absenceFormData.touteLaJournee ? null : absenceFormData.heureFin,
        avecJustificatif: absenceFormData.avecJustificatif // Nouveau champ pour indiquer si l'absence a un justificatif
      };


      const absenceRef = collection(db, 'absences');
      const newAbsenceDoc = doc(absenceRef);
      await setDoc(newAbsenceDoc, absenceData);


      // Si c'est le chef de service qui fait une demande pour lui-même, créer une notification pour l'admin
      if (nature === 'demande' && selectedPerson.id === currentUser.uid) {
        try {
          // Récupérer les admins de l'établissement
          const adminsQuery = query(
            collection(db, 'users'),
            where('establishmentId', '==', userData.establishmentId),
            where('role', '==', 'admin')
          );
          const adminsSnapshot = await getDocs(adminsQuery);
          
          // Créer une notification pour chaque admin
          for (const adminDoc of adminsSnapshot.docs) {
            const notificationData = {
              type: 'absence_request',
              titre: 'Nouvelle demande d\'absence',
              message: `${userData.firstName} ${userData.lastName} (Chef de service - ${userData.service}) a fait une demande d'absence du ${absenceFormData.dateDebut} au ${absenceFormData.dateFin}. Type: ${absenceFormData.type}${absenceFormData.type === 'autre' && absenceFormData.autreType ? ` (${absenceFormData.autreType})` : ''}.`,
              destinataireId: adminDoc.id,
              expediteurId: currentUser.uid,
              expediteurNom: `${userData.firstName} ${userData.lastName}`,
              read: false,
              createdAt: serverTimestamp(),
              establishmentId: userData.establishmentId,
              absenceId: newAbsenceDoc.id,
              chefServiceId: currentUser.uid
            };
            
            await addDoc(collection(db, 'notifications'), notificationData);
          }
        } catch (notifError) {
          console.error('Erreur lors de la création des notifications:', notifError);
          // Ne pas bloquer le processus si la notification échoue
        }
      }

      // Générer automatiquement la fiche d'impression seulement pour les demandes
      if (nature === 'demande') {
        handlePrintAbsence(absenceData, nature, absenceFormData.avecJustificatif);
      }

      setOpenAbsenceDialog(false);
      setAbsenceFormData({
        dateDebut: new Date().toISOString().split('T')[0],
        dateFin: new Date().toISOString().split('T')[0],
        type: 'congé',
        autreType: '',
        motif: '',
        statut: 'en attente',
        nature: 'demande',
        touteLaJournee: true,
        nombreHeures: '',
        heureDebut: '08:00',
        heureFin: '17:00',
        avecJustificatif: false
      });

      // Afficher un message de succès
      setSnackbar({
        open: true,
        message: nature === 'signalement' 
          ? "L'absence a été signalée avec succès."
          : "La demande d'absence a été enregistrée avec succès. La fiche d'impression s'ouvre dans une nouvelle fenêtre.",
        severity: 'success'
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Erreur lors de l'enregistrement de l'absence",
        severity: 'error'
      });
    }
  };

  // Fonction pour imprimer la fiche d'absence
  const handlePrintAbsence = (absenceData, nature, avecJustificatif) => {
    // Déterminer le titre selon le type
    const isSignalement = nature === 'signalement';
    const titre = isSignalement 
      ? (avecJustificatif ? 'SIGNALEMENT D\'ARRÊT AVEC JUSTIFICATIF' : 'SIGNALEMENT D\'ABSENCE')
      : 'DEMANDE D\'ABSENCE';
    
    // Fonction helper pour formater les dates
    const formatDate = (date) => {
      if (!date) return 'N/A';
      const d = date.toDate ? date.toDate() : new Date(date);
      return d.toLocaleDateString('fr-FR', { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    };

    // Fonction helper pour calculer la durée
    const calculateDuration = () => {
      if (absenceData.touteLaJournee) {
        const start = absenceData.dateDebut.toDate ? absenceData.dateDebut.toDate() : new Date(absenceData.dateDebut);
        const end = absenceData.dateFin.toDate ? absenceData.dateFin.toDate() : new Date(absenceData.dateFin);
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
        return `${diffDays} jour${diffDays > 1 ? 's' : ''}`;
      } else {
        return `${absenceData.nombreHeures} heure${absenceData.nombreHeures > 1 ? 's' : ''}`;
      }
    };
    
    // Contenu HTML avec le même format que AbsenceDashboard (format A4 professionnel)
    const extraCss = `
          .print-page {
            font-size: 12px;
            line-height: 1.4;
            color: #333;
          }
          .header { 
            text-align: center; 
            margin-bottom: 15px; 
            padding: 8px;
            border-bottom: 2px solid #333;
          }
          .school-name {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 3px;
          }
          .school-info {
            font-size: 11px;
            margin-bottom: 2px;
          }
          .section { 
            margin-bottom: 12px; 
            padding: 8px;
            border: 1px solid #ddd;
            border-radius: 3px;
          }
          .section h2 {
            font-size: 14px;
            margin: 0 0 8px 0;
            color: #2c3e50;
          }
          .section h3 {
            font-size: 13px;
            margin: 0 0 6px 0;
            color: #34495e;
          }
          .info-line { 
            margin: 6px 0;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            border-bottom: 1px dotted #ccc;
            padding-bottom: 3px;
            min-height: 18px;
          }
          .label {
            font-weight: bold;
            width: 35%;
            font-size: 11px;
          }
          .value {
            width: 65%;
            font-size: 11px;
            text-align: right;
          }
          .status {
            padding: 3px 8px;
            border-radius: 12px;
            font-weight: bold;
            text-align: center;
            display: inline-block;
            font-size: 10px;
          }
          .status.en-attente {
            background-color: #fff3cd;
            color: #856404;
            border: 1px solid #ffeaa7;
          }
          .status.signalée {
            background-color: #d1ecf1;
            color: #0c5460;
            border: 1px solid #bee5eb;
          }
          .signatures {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            page-break-inside: avoid;
          }
          .signature-box {
            width: 45%;
            text-align: center;
          }
          .signature-line {
            margin-top: 50px;
            border-top: 1px solid #000;
            padding-top: 3px;
            font-weight: bold;
            font-size: 10px;
          }
          .date-line {
            margin-top: 10px;
            font-size: 9px;
          }
          .motif-section {
            background-color: #f8f9fa;
            padding: 8px;
            border-left: 3px solid #007bff;
            margin: 8px 0;
          }
          .motif-section h3 {
            margin-bottom: 4px;
          }
          .motif-section p {
            margin: 0;
            font-size: 11px;
            line-height: 1.3;
          }
          .justificatif-note {
            background-color: #fff3cd;
            border-left: 3px solid #ffc107;
            padding: 8px;
            margin: 8px 0;
          }
          .justificatif-note h3 {
            color: #856404;
            margin-bottom: 4px;
          }
          .justificatif-note p {
            color: #856404;
            margin: 0;
            font-size: 11px;
            line-height: 1.3;
          }
          @media print {
            .section {
              break-inside: avoid;
            }
            .signatures {
              break-inside: avoid;
            }
          }
    `;

    const bodyHtml = `
        <div class="print-page">
        <div class="header">
          <div class="school-name">${userData.establishmentName || 'Établissement scolaire'}</div>
          ${userData.academie ? `<div class="school-info">Académie: ${userData.academie}</div>` : ''}
          ${userData.anneeScolaire ? `<div class="school-info">Année scolaire: ${userData.anneeScolaire}</div>` : ''}
          <h1>${titre}</h1>
        </div>
        
        <div class="section">
          <h2>Informations du Personnel</h2>
          <div class="info-line">
            <span class="label">Nom complet:</span>
            <span class="value">${absenceData.nomComplet}</span>
          </div>
          <div class="info-line">
            <span class="label">Service:</span>
            <span class="value">${absenceData.service || userData.service || 'Non spécifié'}</span>
          </div>
        </div>

        <div class="section">
          <h2>Détails de l'Absence</h2>
          <div class="info-line">
            <span class="label">Type d'absence:</span>
            <span class="value">${absenceData.type}</span>
          </div>
          <div class="info-line">
            <span class="label">Date de début:</span>
            <span class="value">${formatDate(absenceData.dateDebut)}</span>
          </div>
          <div class="info-line">
            <span class="label">Date de fin:</span>
            <span class="value">${formatDate(absenceData.dateFin)}</span>
          </div>
          ${!absenceData.touteLaJournee && absenceData.heureDebut && absenceData.heureFin ? `
          <div class="info-line">
            <span class="label">Horaires:</span>
            <span class="value">${absenceData.heureDebut} - ${absenceData.heureFin}</span>
          </div>
          ` : ''}
          <div class="info-line">
            <span class="label">Durée:</span>
            <span class="value">${calculateDuration()}</span>
          </div>
          <div class="info-line">
            <span class="label">Statut:</span>
            <span class="value"><span class="status ${absenceData.statut.replace(' ', '-')}">${absenceData.statut.toUpperCase()}</span></span>
          </div>
          <div class="info-line">
            <span class="label">Date de demande:</span>
            <span class="value">${new Date().toLocaleDateString('fr-FR')}</span>
          </div>
          ${avecJustificatif ? `
          <div class="info-line">
            <span class="label">Justificatif:</span>
            <span class="value">✓ Avec justificatif médical</span>
          </div>
          ` : ''}
        </div>

        ${absenceData.motif ? `
        <div class="motif-section">
          <h3>Motif de l'absence</h3>
          <p>${absenceData.motif}</p>
        </div>
        ` : ''}

        ${isSignalement && avecJustificatif ? `
        <div class="justificatif-note">
          <h3>⚠️ Justificatif Médical Requis</h3>
          <p>Cette absence est justifiée par un document médical officiel (arrêt maladie, certificat médical, etc.). Le justificatif doit être fourni dans les meilleurs délais.</p>
        </div>
        ` : ''}

        ${!isSignalement ? `
        <div class="signatures">
          <div class="signature-box">
            <div>Date et signature de l'agent</div>
            <div class="signature-line">${absenceData.nomComplet}</div>
            <div class="date-line">Date: _______________</div>
          </div>
          <div class="signature-box">
            <div>Date et signature du chef de service</div>
            <div class="signature-line">${userData.firstName || ''} ${userData.lastName || ''}</div>
            <div class="date-line">Date: _______________</div>
          </div>
        </div>
        ` : ''}
      </div>`;

    openPrintWindow(
      `Fiche d'Absence - ${absenceData.nomComplet}`,
      bodyHtml,
      extraCss,
      'height=900,width=1000',
      { singlePage: false, pageMargin: '10mm 8mm' }
    );
  };

  const handleAbsenceChange = (e) => {
    const { name, value } = e.target;

    setAbsenceFormData(prev => {
      const newData = {
        ...prev,
        [name]: value
      };
      return newData;
    });
    
    // Validation immédiate des dates
    if (name === 'dateDebut' || name === 'dateFin') {
      const dateDebut = name === 'dateDebut' ? value : absenceFormData.dateDebut;
      const dateFin = name === 'dateFin' ? value : absenceFormData.dateFin;
      
      
      if (dateDebut && dateFin) {
        const debut = new Date(dateDebut);
        const fin = new Date(dateFin);
        
        
        if (fin < debut) {
          setSnackbar({
            open: true,
            message: 'La date de fin doit être postérieure à la date de début',
            severity: 'warning'
          });
        }
      }
    }
  };

  const fetchPersonSchedule = async (personId) => {
    try {
      const userDoc = await getDoc(doc(db, 'users', personId));
      const userData = userDoc.data();

      // Traitement de l'emploi du temps semaine A
      if (userData?.schedule) {
        const scheduleList = Object.entries(userData.schedule)
          .map(([day, dayData]) => {
            let timeSlot = null;
            let startTime = null;
            let endTime = null;

            if (dayData.continuous.start && dayData.continuous.end) {
              timeSlot = 'continuous';
              startTime = dayData.continuous.start;
              endTime = dayData.continuous.end;
            } else if (dayData.morning.start && dayData.morning.end) {
              timeSlot = 'morning';
              startTime = dayData.morning.start;
              endTime = dayData.morning.end;
            } else if (dayData.afternoon.start && dayData.afternoon.end) {
              timeSlot = 'afternoon';
              startTime = dayData.afternoon.start;
              endTime = dayData.afternoon.end;
            }

            return {
              id: day,
              day: day,
              active: dayData.active,
              timeSlot: timeSlot,
              startTime: startTime,
              endTime: endTime,
              tasks: dayData.tasks?.filter(task => task !== '') || [],
              withBreak: dayData.withBreak || false
            };
          })
          .filter(schedule => schedule.active);

        setSchedule(scheduleList);
      } else {
        setSchedule([]);
      }

      // Traitement de l'emploi du temps semaine B
      if (userData?.hasAlternateSchedule && userData?.scheduleB) {
        const scheduleBList = Object.entries(userData.scheduleB)
          .map(([day, dayData]) => {
            let timeSlot = null;
            let startTime = null;
            let endTime = null;

            if (dayData.continuous.start && dayData.continuous.end) {
              timeSlot = 'continuous';
              startTime = dayData.continuous.start;
              endTime = dayData.continuous.end;
            } else if (dayData.morning.start && dayData.morning.end) {
              timeSlot = 'morning';
              startTime = dayData.morning.start;
              endTime = dayData.morning.end;
            } else if (dayData.afternoon.start && dayData.afternoon.end) {
              timeSlot = 'afternoon';
              startTime = dayData.afternoon.start;
              endTime = dayData.afternoon.end;
            }

            return {
              id: day,
              day: day,
              active: dayData.active,
              timeSlot: timeSlot,
              startTime: startTime,
              endTime: endTime,
              tasks: dayData.tasks?.filter(task => task !== '') || [],
              withBreak: dayData.withBreak || false
            };
          })
          .filter(schedule => schedule.active);

        setScheduleB(scheduleBList);
      } else {
        setScheduleB([]);
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Erreur lors de la récupération de l\'emploi du temps',
        severity: 'error'
      });
    }
  };

  const handleInfoClick = async (person) => {
    try {
      const userDoc = await getDoc(doc(db, 'users', person.id));
      if (!userDoc.exists()) {
        setSnackbar({
          open: true,
          message: 'Utilisateur non trouvé',
          severity: 'error'
        });
        return;
      }
      const userData = userDoc.data();
      
      // Préparer les données pour l'affichage
      const defaultDaySchedule = {
        active: false,
        tasks: [''],
        withBreak: false,
        continuous: { start: '', end: '' },
        morning: { start: '', end: '' },
        afternoon: { start: '', end: '' }
      };

      const defaultSchedule = {
        Lundi: { ...defaultDaySchedule },
        Mardi: { ...defaultDaySchedule },
        Mercredi: { ...defaultDaySchedule },
        Jeudi: { ...defaultDaySchedule },
        Vendredi: { ...defaultDaySchedule },
        Samedi: { ...defaultDaySchedule }
      };

      const schedule = userData.schedule || {};
      const mergedSchedule = Object.keys(defaultSchedule).reduce((acc, day) => {
        const existingDayData = schedule[day] || {};
        const existingTasks = existingDayData.tasks || [''];
        
        acc[day] = {
          ...defaultDaySchedule,
          ...existingDayData,
          tasks: existingTasks.length > 0 ? existingTasks : [''],
          active: existingDayData.active || false,
          withBreak: existingDayData.withBreak || false,
          continuous: {
            start: existingDayData.continuous?.start || '',
            end: existingDayData.continuous?.end || ''
          },
          morning: {
            start: existingDayData.morning?.start || '',
            end: existingDayData.morning?.end || ''
          },
          afternoon: {
            start: existingDayData.afternoon?.start || '',
            end: existingDayData.afternoon?.end || ''
          }
        };
        return acc;
      }, {});

      setSelectedPersonInfo({ ...person, schedule: mergedSchedule });
      setOpenInfoDialog(true);
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Erreur lors de la récupération des données',
        severity: 'error'
      });
    }
  };

// La fonction fetchPersonSchedule est déjà définie plus haut dans le fichier

  const handleAddTaskChange = (day, index, value) => {
    setAddFormData(prevData => {
      const newSchedule = { ...prevData.schedule };
      const newTasks = [...(newSchedule[day].tasks || [''])];
      newTasks[index] = value;
      
      newSchedule[day] = {
        ...newSchedule[day],
        tasks: newTasks
      };
      
      return {
        ...prevData,
        schedule: newSchedule
      };
    });
  };
  
  // Fonction pour gérer les changements de tâches dans la semaine B
  const handleAddTaskChangeB = (day, index, value) => {
    setAddFormData(prevData => {
      const newScheduleB = { ...prevData.scheduleB };
      const newTasks = [...(newScheduleB[day].tasks || [''])];
      newTasks[index] = value;
      
      newScheduleB[day] = {
        ...newScheduleB[day],
        tasks: newTasks
      };
      
      return {
        ...prevData,
        scheduleB: newScheduleB
      };
    });
  };

  const handleOpenAddDialog = () => {
    // Ajouter le samedi à l'emploi du temps s'il n'existe pas déjà
    setAddFormData(prevData => {
      const newSchedule = { ...prevData.schedule };
      
      // Vérifier si le samedi existe déjà
      if (!newSchedule.Samedi) {
        // Ajouter le samedi avec la même structure que les autres jours
        newSchedule.Samedi = { 
          active: false, 
          tasks: [''], 
          withBreak: false, 
          continuous: { start: '', end: '' }, 
          morning: { start: '', end: '' }, 
          afternoon: { start: '', end: '' } 
        };
      }
      
      return {
        ...prevData,
        schedule: newSchedule
      };
    });
    
    // Ouvrir le dialogue d'ajout
    setOpenAddDialog(true);
  };

  const handleAddScheduleChange = (day, field, value) => {
    setAddFormData(prevData => {
      const newSchedule = { ...prevData.schedule };
      
      if (field === 'withBreak') {
        // Réinitialiser les horaires si on change le type d'horaire
        if (value) { // Si on active la pause
          newSchedule[day] = {
            ...newSchedule[day],
            withBreak: true,
            morning: { start: '', end: '' },
            afternoon: { start: '', end: '' },
            continuous: { start: '', end: '' }
          };
        } else { // Si on désactive la pause
          newSchedule[day] = {
            ...newSchedule[day],
            withBreak: false,
            morning: { start: '', end: '' },
            afternoon: { start: '', end: '' },
            continuous: { start: '', end: '' }
          };
        }
      } else if (field.includes('.')) {
        // Gestion des champs imbriqués (ex: morning.start)
        const [parent, child] = field.split('.');
        newSchedule[day] = {
          ...newSchedule[day],
          [parent]: {
            ...newSchedule[day][parent],
            [child]: value
          }
        };
      } else {
        newSchedule[day] = {
          ...newSchedule[day],
          [field]: value
        };
      }
      
      return {
        ...prevData,
        schedule: newSchedule
      };
    });
  };

  // Fonction pour gérer les changements dans l'emploi du temps de la semaine B
  const handleAddScheduleChangeB = (day, field, value) => {
    setAddFormData(prevData => {
      const newScheduleB = { ...prevData.scheduleB };
      
      if (field === 'withBreak') {
        // Réinitialiser les horaires si on change le type d'horaire
        if (value) { // Si on active la pause
          newScheduleB[day] = {
            ...newScheduleB[day],
            withBreak: true,
            morning: { start: '', end: '' },
            afternoon: { start: '', end: '' },
            continuous: { start: '', end: '' }
          };
        } else { // Si on désactive la pause
          newScheduleB[day] = {
            ...newScheduleB[day],
            withBreak: false,
            morning: { start: '', end: '' },
            afternoon: { start: '', end: '' },
            continuous: { start: '', end: '' }
          };
        }
      } else if (field.includes('.')) {
        // Gestion des champs imbriqués (ex: morning.start)
        const [parent, child] = field.split('.');
        newScheduleB[day] = {
          ...newScheduleB[day],
          [parent]: {
            ...newScheduleB[day][parent],
            [child]: value
          }
        };
      } else {
        newScheduleB[day] = {
          ...newScheduleB[day],
          [field]: value
        };
      }
      
      return {
        ...prevData,
        scheduleB: newScheduleB
      };
    });
  };

  const handleRemoveNewTask = (day, index) => {
    setAddFormData(prevData => {
      const newSchedule = { ...prevData.schedule };
      const newTasks = newSchedule[day].tasks.filter((_, i) => i !== index);
      
      newSchedule[day] = {
        ...newSchedule[day],
        tasks: newTasks
      };
      
      return {
        ...prevData,
        schedule: newSchedule
      };
    });
  };
  
  // Fonction pour supprimer une tâche de la semaine B
  const handleRemoveNewTaskB = (day, index) => {
    setAddFormData(prevData => {
      const newScheduleB = { ...prevData.scheduleB };
      const newTasks = newScheduleB[day].tasks.filter((_, i) => i !== index);
      
      newScheduleB[day] = {
        ...newScheduleB[day],
        tasks: newTasks
      };
      
      return {
        ...prevData,
        scheduleB: newScheduleB
      };
    });
  };
  
  // Fonction pour ajouter une nouvelle tâche dans la semaine A
  const handleAddNewTask = (day) => {
    setAddFormData(prevData => {
      const newSchedule = { ...prevData.schedule };
      newSchedule[day] = {
        ...newSchedule[day],
        tasks: [...(newSchedule[day].tasks || []), '']
      };
      
      return {
        ...prevData,
        schedule: newSchedule
      };
    });
  };
  
  // Fonction pour ajouter une nouvelle tâche dans la semaine B
  const handleAddNewTaskB = (day) => {
    setAddFormData(prevData => {
      const newScheduleB = { ...prevData.scheduleB };
      newScheduleB[day] = {
        ...newScheduleB[day],
        tasks: [...(newScheduleB[day].tasks || []), '']
      };
      
      return {
        ...prevData,
        scheduleB: newScheduleB
      };
    });
  };

  // Fonction pour calculer le nombre d'heures entre deux horaires
  const calculateHoursBetween = (start, end) => {
    if (!start || !end) {
      return 0;
    }
    const [startHours, startMinutes] = start.split(':').map(Number);
    const [endHours, endMinutes] = end.split(':').map(Number);
    const hours = (endHours + endMinutes/60) - (startHours + startMinutes/60);
    return hours;
  };

  // Fonction pour calculer le total d'heures hebdomadaires
  const calculateWeeklyHours = (schedule) => {
    if (!schedule) {
      return 0;
    }
    
    let totalHours = 0;
    const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
    
    days.forEach(day => {
      const daySchedule = schedule[day];
      
      if (daySchedule?.active) {
        if (daySchedule.withBreak) {
          const morningHours = calculateHoursBetween(daySchedule.morning?.start, daySchedule.morning?.end);
          const afternoonHours = calculateHoursBetween(daySchedule.afternoon?.start, daySchedule.afternoon?.end);
          totalHours += morningHours + afternoonHours;
        } else {
          const continuousHours = calculateHoursBetween(daySchedule.continuous?.start, daySchedule.continuous?.end);
          totalHours += continuousHours;
        }
      } else {
      }
    });
    
    const roundedHours = Math.round(totalHours * 100) / 100;
    return roundedHours;
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/chef-service/dashboard')}
            sx={{ mb: 2 }}
          >
            Retour au tableau de bord
          </Button>
          <Typography variant="h5" component="h1">
            Gestion du Personnel - {formatService(userData?.service)}
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <TextField
              size="small"
              placeholder="Rechercher..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />,
              }}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', mr: 1 }}>
              <Button
                variant="contained"
                color="success"
                startIcon={<FileDownloadIcon />}
                onClick={handleExportToExcel}
                disabled={excelExportLoading || personnel.length === 0}
              >
                {excelExportLoading ? 'Export...' : 'Exporter Excel'}
              </Button>
              <Typography variant="caption" sx={{ mt: 0.5, textAlign: 'center' }}>
                <a 
                  href="/examples/exemple_export_personnel.xlsx" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: '#1976d2', textDecoration: 'underline' }}
                >
                  Voir un exemple
                </a>
              </Typography>
            </Box>
            <Button
              variant="contained"
              color="primary"
              startIcon={<PersonAddIcon />}
              onClick={() => handleOpenAddDialog()}
            >
              Ajouter un membre
            </Button>
          </Box>
        </Box>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={3}>
            {filteredPersonnel.map((person) => (
              <Grid item xs={12} sm={6} md={4} key={person.id}>
                {person.isCurrentUser && (
                  <Box 
                    sx={{
                      display: 'inline-block',
                      backgroundColor: '#1976d2',
                      color: 'white',
                      padding: '4px 12px',
                      borderRadius: '4px',
                      fontSize: '0.85rem',
                      fontWeight: 'bold',
                      mb: 1,
                      boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
                      zIndex: 2,
                      position: 'relative',
                      left: '10px'
                    }}
                  >
                    Votre fiche
                  </Box>
                )}
                <Card 
                  elevation={3}
                  sx={{
                    height: '100%', 
                    display: 'flex', 
                    flexDirection: 'column',
                    boxShadow: 2,
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: 4
                    },
                    // Ajouter une bordure spéciale pour la fiche du chef de service connecté
                    ...(person.isCurrentUser && {
                      border: '2px solid #1976d2'
                    })
                  }}
                >
                  <CardContent sx={{ flexGrow: 1, pb: 2 }}>
                    <Typography variant="h6" component="h2" gutterBottom sx={{ 
                      fontWeight: 'bold',
                      color: '#1976d2',
                      mb: 2,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1
                    }}>
                      <PersonIcon sx={{ fontSize: 20 }} />
                      {`${person.firstName} ${person.lastName}`}
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="body2" sx={{ 
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: 'text.secondary'
                      }}>
                        <EmailIcon sx={{ fontSize: 18 }} />
                        {person.email}
                      </Typography>

                      <Typography variant="body2" sx={{ 
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: 'text.secondary'
                      }}>
                        <PhoneIcon sx={{ fontSize: 18 }} />
                        {person.phone || 'Non renseigné'}
                      </Typography>

                      <Typography variant="body2" sx={{ 
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: 'text.secondary'
                      }}>
                        <BusinessIcon sx={{ fontSize: 18 }} />
                        {formatService(person?.service)}
                      </Typography>

                      <Typography variant="body2" sx={{ 
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: 'text.secondary'
                      }}>
                        <BusinessIcon sx={{ fontSize: 18 }} />
                        {person.grade || 'Grade non spécifié'}
                      </Typography>

                      <Typography variant="body2" sx={{ 
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: 'text.secondary'
                      }}>
                        <AccessTimeIcon sx={{ fontSize: 18 }} />
                        {person.totalHours || calculateWeeklyHours(person.schedule)} heures/semaine
                      </Typography>

                      <Typography variant="body2" sx={{ 
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: person.status === 'actif' ? 'success.main' : 'error.main'
                      }}>
                        <AccessTimeIcon sx={{ fontSize: 18 }} />
                        {person.status === 'actif' ? 'Actif' : 'Inactif'}
                      </Typography>
                    </Box>
                  </CardContent>

                  <CardActions sx={{ 
                    p: 2, 
                    pt: 0,
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderTop: '1px solid rgba(0, 0, 0, 0.12)'
                  }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Tooltip title="Informations">
                        <IconButton 
                          size="small"
                          onClick={() => handleInfoClick(person)}
                          sx={{ color: 'info.main' }}
                        >
                          <InfoIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Modifier">
                        <IconButton 
                          size="small"
                          onClick={() => handleEditClick(person)}
                          sx={{ color: 'primary.main' }}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Imprimer l'emploi du temps">
                        <IconButton 
                          size="small"
                          onClick={() => handlePrint(person)}
                          sx={{ color: 'action.active' }}
                        >
                          <PrintIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Tableau de bord des absences">
                        <IconButton 
                          size="small"
                          onClick={() => navigate('/chef-service/absences')}
                          sx={{ color: 'info.main' }}
                        >
                          <AssessmentIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Gérer les absences">
                        <IconButton 
                          size="small"
                          onClick={() => handleAbsenceClick(person)}
                          sx={{ color: 'warning.main' }}
                        >
                          <EventBusyIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Heures supplémentaires">
                        <IconButton 
                          size="small"
                          onClick={() => navigate('/chef-service/overtimes', { state: { personnelId: person.id, personnelName: `${person.firstName} ${person.lastName}` } })}
                          sx={{ color: 'success.main' }}
                        >
                          <AccessTimeIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>

                    {/* Désactiver le bouton de suppression pour la propre fiche du chef de service */}
                    {!person.isCurrentUser ? (
                      <Tooltip title="Supprimer">
                        <IconButton 
                          size="small"
                          onClick={() => handleDelete(person.id)}
                          sx={{ 
                            color: 'error.main',
                            '&:hover': {
                              backgroundColor: 'error.light',
                              color: 'error.dark'
                            }
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Vous ne pouvez pas supprimer votre propre compte">
                        <span>
                          <IconButton 
                            size="small"
                            disabled
                            sx={{ color: 'action.disabled' }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Paper>

      {/* Dialog de modification */}
      <Dialog
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            minHeight: '70vh'
          }
        }}
      >
        <DialogTitle sx={{ 
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <EditIcon color="primary" />
          Modifier le personnel
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
            {/* En-tête avec les informations de base */}
            <Box sx={{ 
              p: 3,
              background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
              color: 'white'
            }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Prénom"
                    value={editFormData.firstName}
                    onChange={(e) => setEditFormData({ ...editFormData, firstName: e.target.value })}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        '& fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.3)',
                        },
                        '&:hover fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.5)',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.7)',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'rgba(255, 255, 255, 0.7)',
                      },
                      '& .MuiInputBase-input': {
                        color: 'white',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Nom"
                    value={editFormData.lastName}
                    onChange={(e) => setEditFormData({ ...editFormData, lastName: e.target.value })}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        '& fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.3)',
                        },
                        '&:hover fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.5)',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.7)',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'rgba(255, 255, 255, 0.7)',
                      },
                      '& .MuiInputBase-input': {
                        color: 'white',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Email"
                    value={editFormData.email}
                    onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        '& fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.3)',
                        },
                        '&:hover fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.5)',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.7)',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'rgba(255, 255, 255, 0.7)',
                      },
                      '& .MuiInputBase-input': {
                        color: 'white',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Téléphone"
                    value={editFormData.phone}
                    onChange={(e) => setEditFormData({ ...editFormData, phone: e.target.value })}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        '& fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.3)',
                        },
                        '&:hover fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.5)',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.7)',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'rgba(255, 255, 255, 0.7)',
                      },
                      '& .MuiInputBase-input': {
                        color: 'white',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl 
                    fullWidth
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        '& fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.3)',
                        },
                        '&:hover fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.5)',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.7)',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'rgba(255, 255, 255, 0.7)',
                      },
                      '& .MuiSelect-icon': {
                        color: 'rgba(255, 255, 255, 0.7)',
                      },
                      '& .MuiInputBase-input': {
                        color: 'white',
                      },
                    }}
                  >
                    <InputLabel>{editFormData.isCurrentUser ? "Votre service (non modifiable)" : "Service"}</InputLabel>
                    <Select
                      value={editFormData.service}
                      onChange={(e) => setEditFormData({ ...editFormData, service: e.target.value })}
                      label={editFormData.isCurrentUser ? "Votre service (non modifiable)" : "Service"}
                      disabled={editFormData.isCurrentUser}
                    >
                      {services.map((service) => (
                        <MenuItem key={service} value={service}>
                          {formatService(service)}
                        </MenuItem>
                      ))}
                    </Select>
                    {editFormData.isCurrentUser && (
                      <FormHelperText sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                        Vous ne pouvez pas modifier votre service
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Grade"
                    value={editFormData.grade}
                    onChange={(e) => setEditFormData({ ...editFormData, grade: e.target.value })}
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        '& fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.3)',
                        },
                        '&:hover fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.5)',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.7)',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'rgba(255, 255, 255, 0.7)',
                      },
                      '& .MuiInputBase-input': {
                        color: 'white',
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Section Horaire Décalé */}
            <Box sx={{ p: 3, backgroundColor: 'rgba(245, 245, 245, 0.9)' }}>
              <Typography variant="h6" gutterBottom sx={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                color: 'error.main',
                mb: 2
              }}>
                <AccessTimeIcon />
                Horaire Décalé
              </Typography>
              
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={editFormData.horaireDecale || false}
                        onChange={(e) => setEditFormData({ ...editFormData, horaireDecale: e.target.checked })}
                        color="error"
                      />
                    }
                    label="Horaire décalé"
                  />
                </Grid>
                
                {editFormData.horaireDecale && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Observation horaire décalé"
                      value={editFormData.observationHoraire || ''}
                      onChange={(e) => setEditFormData({ ...editFormData, observationHoraire: e.target.value })}
                      multiline
                      rows={2}
                      variant="outlined"
                    />
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* Section Emploi du temps */}
            <Box sx={{ p: 3 }}>
              <Box sx={{ mb: 2 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={editFormData.hasAlternateSchedule || false}
                      onChange={(e) => setEditFormData({ ...editFormData, hasAlternateSchedule: e.target.checked })}
                      color="primary"
                    />
                  }
                  label="Emploi du temps alternant (semaines A/B)"
                />
              </Box>

              {/* Affichage de l'emploi du temps standard ou semaine A */}
              <Box sx={{ mb: editFormData.hasAlternateSchedule ? 4 : 0 }}>
                <Typography variant="h6" gutterBottom sx={{ 
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  color: editFormData.hasAlternateSchedule ? 'info.main' : 'primary.main',
                  mb: 2
                }}>
                  <ScheduleIcon />
                  {editFormData.hasAlternateSchedule ? "Emploi du temps - Semaine A" : "Emploi du temps hebdomadaire"}
                </Typography>

                <Grid container spacing={2}>
                  {Object.entries(editFormData.schedule || {}).sort(([a], [b]) => {
      const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
      return days.indexOf(a) - days.indexOf(b);
    }).map(([day, daySchedule]) => (
                      <Grid item xs={12} key={day}>
                        <Paper 
                          elevation={0}
                          sx={{ 
                            p: 2,
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 2,
                            '&:hover': {
                              boxShadow: 1
                            }
                          }}
                        >
                      <Box sx={{ 
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 2
                      }}>
                        <Typography variant="h6" sx={{ color: 'primary.main' }}>
                          {day}
                        </Typography>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={daySchedule.active}
                              onChange={(e) => handleScheduleChange(day, 'active', e.target.checked)}
                              color="success"
                            />
                          }
                          label={daySchedule.active ? "Jour travaillé" : "Jour non travaillé"}
                        />
                      </Box>

                      {daySchedule.active && (
                        <Box sx={{ ml: 2 }}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={daySchedule.withBreak}
                                onChange={(e) => handleScheduleChange(day, 'withBreak', e.target.checked)}
                                color="primary"
                              />
                            }
                            label={daySchedule.withBreak ? "Horaires avec pause" : "Horaires continus"}
                          />

                          {daySchedule.withBreak ? (
                            <Grid container spacing={2} sx={{ mt: 1 }}>
                              <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
                                  Matin
                                </Typography>
                                <Grid container spacing={1}>
                                  <Grid item xs={6}>
                                    <TextField
                                      fullWidth
                                      label="Début"
                                      type="time"
                                      value={daySchedule.morning?.start || ''}
                                      onChange={(e) => handleScheduleChange(day, 'morning.start', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      size="small"
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <TextField
                                      fullWidth
                                      label="Fin"
                                      type="time"
                                      value={daySchedule.morning?.end || ''}
                                      onChange={(e) => handleScheduleChange(day, 'morning.end', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      size="small"
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
                                  Après-midi
                                </Typography>
                                <Grid container spacing={1}>
                                  <Grid item xs={6}>
                                    <TextField
                                      fullWidth
                                      label="Début"
                                      type="time"
                                      value={daySchedule.afternoon?.start || ''}
                                      onChange={(e) => handleScheduleChange(day, 'afternoon.start', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      size="small"
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <TextField
                                      fullWidth
                                      label="Fin"
                                      type="time"
                                      value={daySchedule.afternoon?.end || ''}
                                      onChange={(e) => handleScheduleChange(day, 'afternoon.end', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      size="small"
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid container spacing={2} sx={{ mt: 1 }}>
                              <Grid item xs={6}>
                                <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
                                  Horaires continus
                                </Typography>
                                <Grid container spacing={1}>
                                  <Grid item xs={6}>
                                    <TextField
                                      fullWidth
                                      label="Début"
                                      type="time"
                                      value={daySchedule.continuous?.start || ''}
                                      onChange={(e) => handleScheduleChange(day, 'continuous.start', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      size="small"
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <TextField
                                      fullWidth
                                      label="Fin"
                                      type="time"
                                      value={daySchedule.continuous?.end || ''}
                                      onChange={(e) => handleScheduleChange(day, 'continuous.end', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      size="small"
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}

                          <Box sx={{ mt: 2 }}>
                            <Typography variant="subtitle2" sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              color: 'text.secondary'
                            }}>
                              <AssignmentIcon sx={{ fontSize: 18 }} />
                              Tâches
                            </Typography>
                            {daySchedule.tasks?.map((task, taskIndex) => (
                              <Box key={taskIndex} sx={{ 
                                display: 'flex',
                                gap: 1,
                                mb: 1,
                                alignItems: 'center'
                              }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  value={task}
                                  onChange={(e) => handleTaskChange(day, taskIndex, e.target.value)}
                                  placeholder={`Tâche ${taskIndex + 1}`}
                                />
                                <IconButton
                                  size="small"
                                  onClick={() => handleRemoveTask(day, taskIndex)}
                                  sx={{ color: 'error.main' }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Box>
                            ))}
                            <Button
                              size="small"
                              startIcon={<AddIcon />}
                              onClick={() => handleAddTask(day)}
                            >
                              Ajouter une tâche
                            </Button>
                          </Box>
                        </Box>
                      )}
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
            
            {/* Affichage de l'emploi du temps semaine B si alternance activée */}
            {editFormData.hasAlternateSchedule && (
              <Box sx={{ mt: 4, pt: 4, borderTop: '1px dashed', borderColor: 'divider' }}>
                <Typography variant="h6" gutterBottom sx={{ 
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  color: 'secondary.main',
                  mb: 2
                }}>
                  <CalendarTodayIcon />
                  Emploi du temps - Semaine B
                </Typography>

                <Grid container spacing={2}>
                  {Object.entries(editFormData.scheduleB || {}).sort(([a], [b]) => {
      const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
      return days.indexOf(a) - days.indexOf(b);
    }).map(([day, daySchedule]) => (
                    <Grid item xs={12} key={day}>
                      <Paper 
                        elevation={0}
                        sx={{ 
                          p: 2,
                          border: '1px solid',
                          borderColor: 'divider',
                          borderRadius: 2,
                          '&:hover': {
                            boxShadow: 1
                          }
                        }}
                      >
                        <Box sx={{ 
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          mb: 2
                        }}>
                          <Typography variant="h6" sx={{ color: 'secondary.main' }}>
                            {day}
                          </Typography>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={daySchedule.active}
                                onChange={(e) => handleScheduleChangeB(day, 'active', e.target.checked)}
                                color="success"
                              />
                            }
                            label={daySchedule.active ? "Jour travaillé" : "Jour non travaillé"}
                          />
                        </Box>

                        {daySchedule.active && (
                          <Box sx={{ ml: 2 }}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={daySchedule.withBreak}
                                  onChange={(e) => handleScheduleChangeB(day, 'withBreak', e.target.checked)}
                                  color="primary"
                                />
                              }
                              label={daySchedule.withBreak ? "Horaires avec pause" : "Horaires continus"}
                            />

                            {daySchedule.withBreak ? (
                              <Grid container spacing={2} sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={6}>
                                  <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
                                    Matin
                                  </Typography>
                                  <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                      <TextField
                                        fullWidth
                                        label="Début"
                                        type="time"
                                        value={daySchedule.morning?.start || ''}
                                        onChange={(e) => handleScheduleChangeB(day, 'morning.start', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                      />
                                    </Grid>
                                    <Grid item xs={6}>
                                      <TextField
                                        fullWidth
                                        label="Fin"
                                        type="time"
                                        value={daySchedule.morning?.end || ''}
                                        onChange={(e) => handleScheduleChangeB(day, 'morning.end', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
                                    Après-midi
                                  </Typography>
                                  <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                      <TextField
                                        fullWidth
                                        label="Début"
                                        type="time"
                                        value={daySchedule.afternoon?.start || ''}
                                        onChange={(e) => handleScheduleChangeB(day, 'afternoon.start', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                      />
                                    </Grid>
                                    <Grid item xs={6}>
                                      <TextField
                                        fullWidth
                                        label="Fin"
                                        type="time"
                                        value={daySchedule.afternoon?.end || ''}
                                        onChange={(e) => handleScheduleChangeB(day, 'afternoon.end', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            ) : (
                              <Grid container spacing={2} sx={{ mt: 1 }}>
                                <Grid item xs={6}>
                                  <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
                                    Horaires continus
                                  </Typography>
                                  <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                      <TextField
                                        fullWidth
                                        label="Début"
                                        type="time"
                                        value={daySchedule.continuous?.start || ''}
                                        onChange={(e) => handleScheduleChangeB(day, 'continuous.start', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                      />
                                    </Grid>
                                    <Grid item xs={6}>
                                      <TextField
                                        fullWidth
                                        label="Fin"
                                        type="time"
                                        value={daySchedule.continuous?.end || ''}
                                        onChange={(e) => handleScheduleChangeB(day, 'continuous.end', e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}

                            <Box sx={{ mt: 2 }}>
                              <Typography variant="subtitle2" sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                color: 'text.secondary'
                              }}>
                                <AssignmentIcon sx={{ fontSize: 18 }} />
                                Tâches
                              </Typography>
                              {daySchedule.tasks?.map((task, taskIndex) => (
                                <Box key={taskIndex} sx={{ 
                                  display: 'flex',
                                  gap: 1,
                                  mb: 1,
                                  alignItems: 'center'
                                }}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    value={task}
                                    onChange={(e) => handleTaskChangeB(day, taskIndex, e.target.value)}
                                    placeholder={`Tâche ${taskIndex + 1}`}
                                  />
                                  <IconButton
                                    size="small"
                                    onClick={() => handleRemoveTaskB(day, taskIndex)}
                                    sx={{ color: 'error.main' }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Box>
                              ))}
                              <Button
                                size="small"
                                startIcon={<AddIcon />}
                                onClick={() => handleAddTaskB(day)}
                              >
                                Ajouter une tâche
                              </Button>
                            </Box>
                          </Box>
                        )}
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
            </Box>
        </DialogContent>
        <DialogActions sx={{ 
          borderTop: '1px solid',
          borderColor: 'divider',
          p: 2,
          gap: 1
        }}>
          <Button
            onClick={() => setOpenEditDialog(false)}
            startIcon={<CloseIcon />}
          >
            Annuler
          </Button>
          <Button
            onClick={handleEditSubmit}
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            disabled={isSubmitting}
          >
            {isSubmitting ? <CircularProgress size={24} /> : 'Enregistrer'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog d'ajout */}
      <Dialog 
        open={openAddDialog} 
        onClose={() => setOpenAddDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Ajouter un membre</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Prénom"
                value={addFormData.firstName}
                onChange={(e) => setAddFormData({ ...addFormData, firstName: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Nom"
                value={addFormData.lastName}
                onChange={(e) => setAddFormData({ ...addFormData, lastName: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={addFormData.email}
                onChange={(e) => setAddFormData({ ...addFormData, email: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Mot de passe"
                type="password"
                value={addFormData.password}
                onChange={(e) => setAddFormData({ ...addFormData, password: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Téléphone"
                value={addFormData.phone}
                onChange={(e) => setAddFormData({ ...addFormData, phone: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Service</InputLabel>
                <Select
                  value={addFormData.service}
                  label="Service"
                  onChange={(e) => setAddFormData({ ...addFormData, service: e.target.value })}
                >
                  {services.map((service) => (
                    <MenuItem key={service} value={service}>
                      {formatService(service)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Grade</InputLabel>
                <Select
                  value={addFormData.grade}
                  label="Grade"
                  onChange={(e) => setAddFormData({ ...addFormData, grade: e.target.value })}
                >
                  <MenuItem value="Secrétaire Administratif">Secrétaire Administratif</MenuItem>
                  <MenuItem value="Adjoint Administratif">Adjoint Administratif</MenuItem>
                  <MenuItem value="Attaché d'Administration">Attaché d'Administration</MenuItem>
                  <MenuItem value="Gestionnaire">Gestionnaire</MenuItem>
                  <MenuItem value="Assistant de Direction">Assistant de Direction</MenuItem>
                  <MenuItem value="Contractuel">Contractuel</MenuItem>
                  <MenuItem value="Technicien">Technicien</MenuItem>
                  <MenuItem value="ATTE2">ATTE2</MenuItem>
                  <MenuItem value="ATTEP2">ATTEP2</MenuItem>
                  <MenuItem value="ATTEP1">ATTEP1</MenuItem>
                  <MenuItem value="Agent de Maitrise">Agent de Maitrise</MenuItem>
                  <MenuItem value="Autre">Autre</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Statut</InputLabel>
                <Select
                  value={addFormData.status}
                  label="Statut"
                  onChange={(e) => setAddFormData({ ...addFormData, status: e.target.value })}
                >
                  <MenuItem value="actif">Actif</MenuItem>
                  <MenuItem value="inactif">Inactif</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={addFormData.horaireDecale || false}
                    onChange={(e) => setAddFormData({ ...addFormData, horaireDecale: e.target.checked })}
                    color="primary"
                  />
                }
                label="Horaire décalé"
              />
            </Grid>
            
            {addFormData.horaireDecale && (
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Observation horaire décalé"
                  value={addFormData.observationHoraire || ''}
                  onChange={(e) => setAddFormData({ ...addFormData, observationHoraire: e.target.value })}
                  multiline
                  rows={2}
                />
              </Grid>
            )}
            
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={addFormData.hasAlternateSchedule || false}
                    onChange={(e) => setAddFormData({ ...addFormData, hasAlternateSchedule: e.target.checked })}
                    color="primary"
                  />
                }
                label="Emploi du temps alternant (semaines A/B)"
              />
            </Grid>

            {/* Section Emploi du temps */}
            <Grid item xs={12}>
              {!addFormData.hasAlternateSchedule ? (
                <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                  Emploi du temps
                </Typography>
              ) : (
                <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                  Emploi du temps - Semaine A
                </Typography>
              )}
              {Object.entries(addFormData.schedule).sort(([a], [b]) => {
      const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
      return days.indexOf(a) - days.indexOf(b);
    }).map(([day, schedule]) => (
                <Accordion key={day}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>{day}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={schedule.active}
                              onChange={(e) => handleAddScheduleChange(day, 'active', e.target.checked)}
                            />
                          }
                          label="Jour actif"
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              checked={schedule.withBreak}
                              onChange={(e) => handleAddScheduleChange(day, 'withBreak', e.target.checked)}
                            />
                          }
                          label="Avec pause"
                        />
                      </Grid>

                      {/* Horaires */}
                      <Grid item xs={12}>
                        {schedule.withBreak ? (
                          <>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle1">Matin</Typography>
                                <Grid container spacing={1}>
                                  <Grid item xs={6}>
                                    <TextField
                                      type="time"
                                      label="Début"
                                      value={schedule.morning.start}
                                      onChange={(e) => handleTimeChange(day, 'morning', 'start', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <TextField
                                      type="time"
                                      label="Fin"
                                      value={schedule.morning.end}
                                      onChange={(e) => handleTimeChange(day, 'morning', 'end', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      fullWidth
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle1">Après-midi</Typography>
                                <Grid container spacing={1}>
                                  <Grid item xs={6}>
                                    <TextField
                                      type="time"
                                      label="Début"
                                      value={schedule.afternoon.start}
                                      onChange={(e) => handleTimeChange(day, 'afternoon', 'start', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <TextField
                                      type="time"
                                      label="Fin"
                                      value={schedule.afternoon.end}
                                      onChange={(e) => handleTimeChange(day, 'afternoon', 'end', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      fullWidth
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          <>
                            <Typography variant="subtitle1">Horaires continus</Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <TextField
                                  type="time"
                                  label="Début"
                                  value={schedule.continuous.start}
                                  onChange={(e) => handleTimeChange(day, 'continuous', 'start', e.target.value)}
                                  InputLabelProps={{ shrink: true }}
                                  fullWidth
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <TextField
                                  type="time"
                                  label="Fin"
                                  value={schedule.continuous.end}
                                  onChange={(e) => handleTimeChange(day, 'continuous', 'end', e.target.value)}
                                  InputLabelProps={{ shrink: true }}
                                  fullWidth
                                />
                              </Grid>
                            </Grid>
                          </>
                        )}
                      </Grid>

                      {/* Tâches */}
                      <Grid item xs={12}>
                        <Typography variant="subtitle1">Tâches</Typography>
                        {schedule.tasks.map((task, index) => (
                          <Box key={index} sx={{ 
                            display: 'flex',
                            gap: 1,
                            mb: 1,
                            alignItems: 'center'
                          }}>
                            <TextField
                              fullWidth
                              size="small"
                              value={task}
                              onChange={(e) => handleAddTaskChange(day, index, e.target.value)}
                              placeholder={`Tâche ${index + 1}`}
                            />
                            <IconButton 
                              size="small" 
                              color="error"
                              onClick={() => handleRemoveNewTask(day, index)}
                              disabled={schedule.tasks.length === 1}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        ))}
                        <Button
                          size="small"
                          startIcon={<AddIcon />}
                          onClick={() => handleAddNewTask(day)}
                        >
                          Ajouter une tâche
                        </Button>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ))}
              
              {/* Section Emploi du temps Semaine B */}
              {addFormData.hasAlternateSchedule && (
                <>
                  <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
                    Emploi du temps - Semaine B
                  </Typography>
                  {Object.entries(addFormData.scheduleB).sort(([a], [b]) => {
      const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
      return days.indexOf(a) - days.indexOf(b);
    }).map(([day, schedule]) => (
                    <Accordion key={`B-${day}`}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>{day}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={schedule.active}
                                  onChange={(e) => handleAddScheduleChangeB(day, 'active', e.target.checked)}
                                />
                              }
                              label="Jour actif"
                            />
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={schedule.withBreak}
                                  onChange={(e) => handleAddScheduleChangeB(day, 'withBreak', e.target.checked)}
                                />
                              }
                              label="Avec pause"
                            />
                          </Grid>

                          {/* Horaires */}
                          <Grid item xs={12}>
                            {schedule.withBreak ? (
                              <>
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1">Matin</Typography>
                                    <Grid container spacing={1}>
                                      <Grid item xs={6}>
                                        <TextField
                                          type="time"
                                          label="Début"
                                          value={schedule.morning.start}
                                          onChange={(e) => handleTimeChangeB(day, 'morning', 'start', e.target.value)}
                                          InputLabelProps={{ shrink: true }}
                                          fullWidth
                                        />
                                      </Grid>
                                      <Grid item xs={6}>
                                        <TextField
                                          type="time"
                                          label="Fin"
                                          value={schedule.morning.end}
                                          onChange={(e) => handleTimeChangeB(day, 'morning', 'end', e.target.value)}
                                          InputLabelProps={{ shrink: true }}
                                          fullWidth
                                        />
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1">Après-midi</Typography>
                                    <Grid container spacing={1}>
                                      <Grid item xs={6}>
                                        <TextField
                                          type="time"
                                          label="Début"
                                          value={schedule.afternoon.start}
                                          onChange={(e) => handleTimeChangeB(day, 'afternoon', 'start', e.target.value)}
                                          InputLabelProps={{ shrink: true }}
                                          fullWidth
                                        />
                                      </Grid>
                                      <Grid item xs={6}>
                                        <TextField
                                          type="time"
                                          label="Fin"
                                          value={schedule.afternoon.end}
                                          onChange={(e) => handleTimeChangeB(day, 'afternoon', 'end', e.target.value)}
                                          InputLabelProps={{ shrink: true }}
                                          fullWidth
                                        />
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </>
                            ) : (
                              <>
                                <Typography variant="subtitle1">Horaires continus</Typography>
                                <Grid container spacing={2}>
                                  <Grid item xs={6}>
                                    <TextField
                                      type="time"
                                      label="Début"
                                      value={schedule.continuous.start}
                                      onChange={(e) => handleTimeChangeB(day, 'continuous', 'start', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <TextField
                                      type="time"
                                      label="Fin"
                                      value={schedule.continuous.end}
                                      onChange={(e) => handleTimeChangeB(day, 'continuous', 'end', e.target.value)}
                                      InputLabelProps={{ shrink: true }}
                                      fullWidth
                                    />
                                  </Grid>
                                </Grid>
                              </>
                            )}
                          </Grid>

                          {/* Tâches */}
                          <Grid item xs={12}>
                            <Typography variant="subtitle1">Tâches</Typography>
                            {schedule.tasks.map((task, index) => (
                              <Box key={index} sx={{ 
                                display: 'flex',
                                gap: 1,
                                mb: 1,
                                alignItems: 'center'
                              }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  value={task}
                                  onChange={(e) => handleAddTaskChangeB(day, index, e.target.value)}
                                  placeholder={`Tâche ${index + 1}`}
                                />
                                <IconButton 
                                  size="small" 
                                  color="error"
                                  onClick={() => handleRemoveNewTaskB(day, index)}
                                  disabled={addFormData.scheduleB[day].tasks.length === 1}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Box>
                            ))}
                            <Button
                              size="small"
                              startIcon={<AddIcon />}
                              onClick={() => handleAddNewTaskB(day)}
                            >
                              Ajouter une tâche
                            </Button>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddDialog(false)}>Annuler</Button>
          <Button 
            variant="contained" 
            onClick={handleAddSubmit}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Ajouter'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog Absence : mode signalement ou demande ── */}
      <Dialog open={openAbsenceDialog} onClose={handleCloseAbsenceDialog} maxWidth="sm" fullWidth>

        {/* En-tête */}
        <DialogTitle sx={{ pb: 0 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a2332' }}>
                Gestion d'absence
              </Typography>
              <Typography variant="body2" sx={{ color: '#4a5568', mt: 0.25 }}>
                {selectedPerson?.firstName} {selectedPerson?.lastName}
              </Typography>
            </Box>
            <Button
              variant="text"
              size="small"
              startIcon={<EventNoteIcon />}
              onClick={() => navigate('/chef-service/my-absences')}
              sx={{ color: '#0f4c5c', whiteSpace: 'nowrap', mt: 0.5 }}
            >
              Mes demandes
            </Button>
          </Box>
        </DialogTitle>

        <form onSubmit={(e) => handleAbsenceSubmit(e, absenceFormData.nature)}>
          <DialogContent sx={{ pt: 2 }}>
            <Grid container spacing={2}>

              {/* ── Sélecteur de mode ── */}
              <Grid item xs={12}>
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#4a5568', letterSpacing: '0.08em', textTransform: 'uppercase', display: 'block', mb: 1 }}>
                  Que souhaitez-vous faire ?
                </Typography>
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>

                  {/* Carte : Signaler */}
                  <Box
                    onClick={() => setAbsenceFormData({ ...absenceFormData, nature: 'signalement' })}
                    sx={{
                      p: 1.75,
                      borderRadius: '12px',
                      border: absenceFormData.nature === 'signalement'
                        ? '2px solid #d97706'
                        : '2px solid #e2e8f0',
                      background: absenceFormData.nature === 'signalement'
                        ? 'linear-gradient(135deg, #fffbeb, #fef3c7)'
                        : '#f8fafc',
                      cursor: 'pointer',
                      transition: 'all 0.18s ease',
                      '&:hover': { borderColor: '#d97706', background: '#fffbeb' },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
                      <Box sx={{
                        width: 30, height: 30, borderRadius: '8px',
                        background: absenceFormData.nature === 'signalement' ? '#d97706' : '#e2e8f0',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                        transition: 'background 0.18s',
                      }}>
                        <EventBusyIcon sx={{ fontSize: 17, color: absenceFormData.nature === 'signalement' ? '#fff' : '#94a3b8' }} />
                      </Box>
                      <Typography sx={{ fontWeight: 700, fontSize: '0.875rem', color: absenceFormData.nature === 'signalement' ? '#92400e' : '#374151' }}>
                        Signaler une absence
                      </Typography>
                    </Box>
                    <Typography sx={{ fontSize: '0.775rem', color: '#64748b', lineHeight: 1.5 }}>
                      L'agent <strong>est ou était absent</strong> (passé ou en cours). Enregistrement immédiat, sans approbation requise.
                    </Typography>
                    {absenceFormData.nature === 'signalement' && (
                      <Chip label="Mode sélectionné" size="small" sx={{ mt: 1, background: '#d97706', color: '#fff', fontWeight: 600, height: 20, fontSize: '0.68rem' }} />
                    )}
                  </Box>

                  {/* Carte : Demande */}
                  <Box
                    onClick={() => setAbsenceFormData({ ...absenceFormData, nature: 'demande' })}
                    sx={{
                      p: 1.75,
                      borderRadius: '12px',
                      border: absenceFormData.nature === 'demande'
                        ? '2px solid #0f4c5c'
                        : '2px solid #e2e8f0',
                      background: absenceFormData.nature === 'demande'
                        ? 'linear-gradient(135deg, #f0f9ff, #e0f2fe)'
                        : '#f8fafc',
                      cursor: 'pointer',
                      transition: 'all 0.18s ease',
                      '&:hover': { borderColor: '#0f4c5c', background: '#f0f9ff' },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
                      <Box sx={{
                        width: 30, height: 30, borderRadius: '8px',
                        background: absenceFormData.nature === 'demande' ? '#0f4c5c' : '#e2e8f0',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                        transition: 'background 0.18s',
                      }}>
                        <AssignmentIcon sx={{ fontSize: 17, color: absenceFormData.nature === 'demande' ? '#fff' : '#94a3b8' }} />
                      </Box>
                      <Typography sx={{ fontWeight: 700, fontSize: '0.875rem', color: absenceFormData.nature === 'demande' ? '#0f4c5c' : '#374151' }}>
                        Demande de congé
                      </Typography>
                    </Box>
                    <Typography sx={{ fontSize: '0.775rem', color: '#64748b', lineHeight: 1.5 }}>
                      L'agent <strong>souhaite s'absenter</strong> prochainement. Envoyé pour approbation + fiche PDF générée.
                    </Typography>
                    {absenceFormData.nature === 'demande' && (
                      <Chip label="Mode sélectionné" size="small" sx={{ mt: 1, background: '#0f4c5c', color: '#fff', fontWeight: 600, height: 20, fontSize: '0.68rem' }} />
                    )}
                  </Box>
                </Box>

                {/* Bannière contextuelle selon le mode */}
                <Box sx={{
                  mt: 1.5, p: 1.25, borderRadius: '8px',
                  background: absenceFormData.nature === 'signalement' ? 'rgba(217,119,6,0.08)' : 'rgba(15,76,92,0.07)',
                  border: `1px solid ${absenceFormData.nature === 'signalement' ? 'rgba(217,119,6,0.2)' : 'rgba(15,76,92,0.15)'}`,
                  display: 'flex', alignItems: 'flex-start', gap: 1,
                }}>
                  <InfoIcon sx={{ fontSize: 16, color: absenceFormData.nature === 'signalement' ? '#d97706' : '#0f4c5c', mt: 0.1, flexShrink: 0 }} />
                  <Typography sx={{ fontSize: '0.78rem', color: absenceFormData.nature === 'signalement' ? '#92400e' : '#0f4c5c', lineHeight: 1.5 }}>
                    {absenceFormData.nature === 'signalement'
                      ? 'Signalement : les dates passées sont autorisées. L\'absence est enregistrée directement avec le statut "Signalée".'
                      : 'Demande : la date de début doit être dans le futur. Une fiche d\'autorisation PDF sera générée et l\'administrateur sera notifié.'}
                  </Typography>
                </Box>
              </Grid>

              {/* Séparateur */}
              <Grid item xs={12}>
                <Box sx={{ borderTop: '1px solid #e2e8f0', pt: 0.5 }} />
              </Grid>

              {/* Dates */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Date de début"
                  type="date"
                  name="dateDebut"
                  value={absenceFormData.dateDebut}
                  onChange={handleAbsenceChange}
                  InputLabelProps={{ shrink: true }}
                  // Signalement → dates passées OK / Demande → uniquement futur
                  inputProps={absenceFormData.nature === 'demande'
                    ? { min: new Date().toISOString().split('T')[0] }
                    : {}}
                  required
                  error={absenceFormData.dateDebut === ''}
                  helperText={
                    absenceFormData.dateDebut === ''
                      ? 'La date de début est requise'
                      : absenceFormData.nature === 'signalement'
                        ? 'Passée ou actuelle'
                        : 'Doit être dans le futur'
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Date de fin"
                  type="date"
                  name="dateFin"
                  value={absenceFormData.dateFin}
                  onChange={handleAbsenceChange}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: absenceFormData.dateDebut }}
                  required
                  error={absenceFormData.dateFin !== '' && new Date(absenceFormData.dateFin) < new Date(absenceFormData.dateDebut)}
                  helperText={
                    new Date(absenceFormData.dateFin) < new Date(absenceFormData.dateDebut)
                      ? 'Doit être après la date de début'
                      : ''
                  }
                />
              </Grid>

              {/* Type d'absence */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Type d'absence</InputLabel>
                  <Select name="type" value={absenceFormData.type} onChange={handleAbsenceChange} required>
                    <MenuItem value="congé">Congé</MenuItem>
                    <MenuItem value="maladie">Maladie</MenuItem>
                    <MenuItem value="formation">Formation</MenuItem>
                    <MenuItem value="autre">Autre</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {absenceFormData.type === 'autre' && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Précisez le type d'absence"
                    name="autreType"
                    value={absenceFormData.autreType}
                    onChange={handleAbsenceChange}
                    placeholder="Ex: Rendez-vous administratif, Événement familial, etc."
                    required
                    helperText="Veuillez préciser le type d'absence"
                  />
                </Grid>
              )}

              {/* Justificatif */}
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={absenceFormData.avecJustificatif || false}
                      onChange={(e) => setAbsenceFormData({ ...absenceFormData, avecJustificatif: e.target.checked })}
                      name="avecJustificatif"
                      color="primary"
                    />
                  }
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                      <Typography sx={{ fontSize: '0.875rem' }}>Avec justificatif</Typography>
                      <Tooltip title="Arrêt maladie, certificat médical, convocation officielle, etc.">
                        <InfoIcon fontSize="small" color="info" />
                      </Tooltip>
                    </Box>
                  }
                />
              </Grid>

              {/* Toute la journée */}
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={absenceFormData.touteLaJournee}
                      onChange={(e) => setAbsenceFormData({
                        ...absenceFormData,
                        touteLaJournee: e.target.checked,
                        nombreHeures: e.target.checked ? '' : absenceFormData.nombreHeures,
                      })}
                      name="touteLaJournee"
                    />
                  }
                  label="Absence pour toute la journée"
                />
              </Grid>

              {!absenceFormData.touteLaJournee && (
                <>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth label="Nb d'heures" name="nombreHeures" type="number"
                      value={absenceFormData.nombreHeures} onChange={handleAbsenceChange}
                      inputProps={{ min: 0.5, max: 24, step: 0.5 }}
                      InputProps={{ endAdornment: <InputAdornment position="end">h</InputAdornment> }}
                      required={!absenceFormData.touteLaJournee}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth label="Heure de début" name="heureDebut" type="time"
                      value={absenceFormData.heureDebut} onChange={handleAbsenceChange}
                      InputLabelProps={{ shrink: true }}
                      required={!absenceFormData.touteLaJournee}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth label="Heure de fin" name="heureFin" type="time"
                      value={absenceFormData.heureFin} onChange={handleAbsenceChange}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: absenceFormData.heureDebut }}
                      required={!absenceFormData.touteLaJournee}
                    />
                  </Grid>
                </>
              )}

              {/* Motif */}
              <Grid item xs={12}>
                <TextField
                  fullWidth label="Motif" name="motif"
                  value={absenceFormData.motif} onChange={handleAbsenceChange}
                  multiline rows={3} required
                  placeholder={absenceFormData.nature === 'signalement'
                    ? 'Ex : Absent sans préavis ce matin, a prévenu par téléphone...'
                    : 'Ex : Congé annuel, démarche administrative, rendez-vous médical...'}
                />
              </Grid>
            </Grid>
          </DialogContent>

          {/* ── Actions ── */}
          <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1, borderTop: '1px solid #e2e8f0' }}>
            <Button onClick={() => setOpenAbsenceDialog(false)} sx={{ color: '#4a5568' }}>
              Annuler
            </Button>

            {/* Bouton unique qui s'adapte au mode */}
            <Button
              type="submit"
              variant="contained"
              startIcon={absenceFormData.nature === 'signalement' ? <EventBusyIcon /> : <AssignmentIcon />}
              sx={{
                px: 3,
                background: absenceFormData.nature === 'signalement'
                  ? 'linear-gradient(135deg, #d97706, #f59e0b)'
                  : 'linear-gradient(135deg, #0f4c5c, #1a6b80)',
                boxShadow: absenceFormData.nature === 'signalement'
                  ? '0 4px 14px rgba(217,119,6,0.35)'
                  : '0 4px 14px rgba(15,76,92,0.35)',
                '&:hover': {
                  background: absenceFormData.nature === 'signalement'
                    ? 'linear-gradient(135deg, #b45309, #d97706)'
                    : 'linear-gradient(135deg, #093340, #0f4c5c)',
                },
              }}
            >
              {absenceFormData.nature === 'signalement'
                ? 'Enregistrer le signalement'
                : 'Soumettre la demande'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Dialog des détails */}
      <Dialog 
        open={openDetailsDialog} 
        onClose={handleCloseDetailsDialog} 
        maxWidth="md" 
        fullWidth
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <PersonIcon />
            Détails - {selectedPerson?.firstName} {selectedPerson?.lastName}
          </Box>
        </DialogTitle>
        <DialogContent>
          {loadingDetails ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: 3, width: '100%' }}>
                  <Typography variant="h5" gutterBottom align="center" sx={{ mb: 3 }}>
                    {selectedPerson?.firstName} {selectedPerson?.lastName}
                  </Typography>
                  <Typography variant="h6" gutterBottom align="center" color="text.secondary">
                    {selectedPerson?.role || "SERVICE GENERAL"}
                  </Typography>
                  <Typography variant="subtitle1" gutterBottom align="center" sx={{ mb: 2 }}>
                    Total hebdomadaire : {selectedPerson?.weeklyHours || "40.0"} heures
                  </Typography>
                  
                  {selectedPerson?.hasAlternateSchedule && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
                      <Typography variant="subtitle1" color="primary.main" fontWeight="bold">
                        Emploi du temps alterné (Semaines A/B)
                      </Typography>
                    </Box>
                  )}
                  
                  {selectedPerson?.horaireDecale && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
                      <Typography variant="subtitle1" color="error.main" fontWeight="bold">
                        Horaire décalé
                      </Typography>
                      {selectedPerson?.observationHoraire && (
                        <Typography variant="body2" color="text.secondary" align="center">
                          {selectedPerson.observationHoraire}
                        </Typography>
                      )}
                    </Box>
                  )}

                  {selectedPerson?.hasAlternateSchedule && (
                    <Box sx={{ mb: 3 }}>
                      <Typography variant="h6" align="center" sx={{ 
                        mb: 2, 
                        backgroundColor: 'primary.main', 
                        color: 'white', 
                        py: 1,
                        borderRadius: 1
                      }}>
                        Semaine A
                      </Typography>
                    </Box>
                  )}
                  
                  {schedule.map((item) => (
                    <Box 
                      key={item.id} 
                      sx={{ 
                        mb: 2,
                        backgroundColor: 'grey.50',
                        borderRadius: 1,
                        p: 2
                      }}
                    >
                      <Typography 
                        variant="subtitle1" 
                        sx={{ 
                          fontWeight: 'bold', 
                          mb: 1,
                          color: 'primary.main',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <ScheduleIcon sx={{ mr: 1, fontSize: 'small' }} />
                        {item.day}
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
                        <Typography variant="body2" sx={{
                          display: 'flex',
                          alignItems: 'center',
                          backgroundColor: 'action.hover',
                          p: 1,
                          borderRadius: 1
                        }}>
                          <AccessTimeIcon sx={{ mr: 1, fontSize: 'small' }} />
                          {formatTime(item.startTime)} - {formatTime(item.endTime)}
                        </Typography>
                        {item.withBreak && (
                          <Typography variant="body2" color="info.main" sx={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: 'info.lighter',
                            p: 1,
                            borderRadius: 1
                          }}>
                            <InfoIcon sx={{ mr: 1, fontSize: 'small' }} />
                            Avec pause
                          </Typography>
                        )}
                        {item.tasks && item.tasks.length > 0 && (
                          <Box sx={{ mt: 'auto' }}>
                            <Typography variant="body2" sx={{ 
                              fontWeight: 'medium', 
                              mb: 0.5,
                              display: 'flex',
                              alignItems: 'center',
                              color: 'text.secondary'
                            }}>
                              <AssignmentIcon sx={{ mr: 1, fontSize: 'small' }} />
                              Tâches:
                            </Typography>
                            <List dense sx={{ 
                              backgroundColor: 'background.paper',
                              borderRadius: 1,
                              '& .MuiListItem-root': { px: 1 }
                            }}>
                              {item.tasks.map((task, index) => (
                                <ListItem key={index} sx={{ py: 0.5 }}>
                                  <ListItemIcon sx={{ minWidth: 24 }}>
                                    <FiberManualRecordIcon sx={{ fontSize: 8, color: 'primary.main' }} />
                                  </ListItemIcon>
                                  <ListItemText 
                                    primary={task} 
                                    primaryTypographyProps={{ 
                                      variant: 'body2',
                                      sx: { fontWeight: 'medium' }
                                    }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  ))}
                  
                  {/* Affichage de l'emploi du temps semaine B si disponible */}
                  {selectedPerson?.hasAlternateSchedule && scheduleB.length > 0 && (
                    <>
                      <Box sx={{ mb: 3, mt: 4 }}>
                        <Typography variant="h6" align="center" sx={{ 
                          mb: 2, 
                          backgroundColor: 'secondary.main', 
                          color: 'white', 
                          py: 1,
                          borderRadius: 1
                        }}>
                          Semaine B
                        </Typography>
                      </Box>
                      
                      {scheduleB.map((item) => (
                        <Box 
                          key={item.id} 
                          sx={{ 
                            mb: 2,
                            backgroundColor: 'grey.100',
                            borderRadius: 1,
                            p: 2
                          }}
                        >
                          <Typography 
                            variant="subtitle1" 
                            sx={{ 
                              fontWeight: 'bold', 
                              mb: 1,
                              color: 'secondary.main',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            <ScheduleIcon sx={{ mr: 1, fontSize: 'small' }} />
                            {item.day}
                          </Typography>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
                            <Typography variant="body2" sx={{
                              display: 'flex',
                              alignItems: 'center',
                              backgroundColor: 'action.hover',
                              p: 1,
                              borderRadius: 1
                            }}>
                              <AccessTimeIcon sx={{ mr: 1, fontSize: 'small' }} />
                              {formatTime(item.startTime)} - {formatTime(item.endTime)}
                            </Typography>
                            {item.withBreak && (
                              <Typography variant="body2" color="info.main" sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: 'info.lighter',
                                p: 1,
                                borderRadius: 1
                              }}>
                                <InfoIcon sx={{ mr: 1, fontSize: 'small' }} />
                                Avec pause
                              </Typography>
                            )}
                            {item.tasks && item.tasks.length > 0 && (
                              <Box sx={{ mt: 'auto' }}>
                                <Typography variant="body2" sx={{ 
                                  fontWeight: 'medium', 
                                  mb: 0.5,
                                  display: 'flex',
                                  alignItems: 'center',
                                  color: 'text.secondary'
                                }}>
                                  <AssignmentIcon sx={{ mr: 1, fontSize: 'small' }} />
                                  Tâches:
                                </Typography>
                                <List dense sx={{ 
                                  backgroundColor: 'background.paper',
                                  borderRadius: 1,
                                  '& .MuiListItem-root': { px: 1 }
                                }}>
                                  {item.tasks.map((task, index) => (
                                    <ListItem key={index} sx={{ py: 0.5 }}>
                                      <ListItemIcon sx={{ minWidth: 24 }}>
                                        <FiberManualRecordIcon sx={{ fontSize: 8, color: 'secondary.main' }} />
                                      </ListItemIcon>
                                      <ListItemText 
                                        primary={task} 
                                        primaryTypographyProps={{ 
                                          variant: 'body2',
                                          sx: { fontWeight: 'medium' }
                                        }}
                                      />
                                    </ListItem>
                                  ))}
                                </List>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      ))}
                    </>
                  )}
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
                      <CalendarTodayIcon sx={{ mr: 1 }} />
                      {selectedPerson?.hasAlternateSchedule ? 'Planning hebdomadaire - Semaine A' : 'Planning hebdomadaire'}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {schedule.length > 0 ? (
                      <Grid container spacing={2}>
                        {schedule.map((item) => (
                          <Grid item xs={12} sm={6} md={4} key={item.id}>
                            <Paper 
                              sx={{ 
                                p: 2,
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                borderLeft: 4,
                                borderColor: 'primary.main'
                              }}
                            >
                              <Typography 
                                variant="subtitle1" 
                                sx={{ 
                                  color: 'primary.main',
                                  mb: 1
                                }}
                              >
                                {item.day}
                              </Typography>
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
                                <Typography variant="body2" sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  backgroundColor: 'action.hover',
                                  p: 1,
                                  borderRadius: 1
                                }}>
                                  <AccessTimeIcon sx={{ mr: 1, fontSize: 'small' }} />
                                  {formatTime(item.startTime)} - {formatTime(item.endTime)}
                                </Typography>
                                {item.withBreak && (
                                  <Typography variant="body2" color="info.main" sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: 'info.lighter',
                                    p: 1,
                                    borderRadius: 1
                                  }}>
                                    <InfoIcon sx={{ mr: 1, fontSize: 'small' }} />
                                    Avec pause
                                  </Typography>
                                )}
                                {item.tasks && item.tasks.length > 0 && (
                                  <Box sx={{ mt: 'auto' }}>
                                    <Typography variant="body2" sx={{ 
                                      fontWeight: 'medium', 
                                      mb: 0.5,
                                      display: 'flex',
                                      alignItems: 'center',
                                      color: 'text.secondary'
                                    }}>
                                      <AssignmentIcon sx={{ mr: 1, fontSize: 'small' }} />
                                      Tâches:
                                    </Typography>
                                    <List dense sx={{ 
                                      backgroundColor: 'background.paper',
                                      borderRadius: 1,
                                      '& .MuiListItem-root': { px: 1 }
                                    }}>
                                      {item.tasks.map((task, index) => (
                                        <ListItem key={index} sx={{ py: 0.5 }}>
                                          <ListItemIcon sx={{ minWidth: 24 }}>
                                            <FiberManualRecordIcon sx={{ fontSize: 8, color: 'primary.main' }} />
                                          </ListItemIcon>
                                          <ListItemText 
                                            primary={task} 
                                            primaryTypographyProps={{ 
                                              variant: 'body2',
                                              sx: { fontWeight: 'medium' }
                                            }}
                                          />
                                        </ListItem>
                                      ))}
                                    </List>
                                  </Box>
                                )}
                              </Box>
                            </Paper>
                          </Grid>
                        ))}
                      </Grid>
                    ) : (
                      <Typography align="center" color="text.secondary">
                        Aucun planning disponible
                      </Typography>
                    )}
                  </AccordionDetails>
                </Accordion>
                
                {/* Planning hebdomadaire semaine B */}
                {selectedPerson?.hasAlternateSchedule && (
                  <Accordion defaultExpanded sx={{ mt: 2 }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', color: 'secondary.main' }}>
                        <CalendarTodayIcon sx={{ mr: 1 }} />
                        Planning hebdomadaire - Semaine B
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {scheduleB.length > 0 ? (
                        <Grid container spacing={2}>
                          {scheduleB.map((item) => (
                            <Grid item xs={12} sm={6} md={4} key={item.id}>
                              <Paper 
                                sx={{ 
                                  p: 2,
                                  height: '100%',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  borderLeft: 4,
                                  borderColor: 'secondary.main'
                                }}
                              >
                                <Typography 
                                  variant="subtitle1" 
                                  sx={{ 
                                    color: 'secondary.main',
                                    mb: 1
                                  }}
                                >
                                  {item.day}
                                </Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
                                  <Typography variant="body2" sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: 'action.hover',
                                    p: 1,
                                    borderRadius: 1
                                  }}>
                                    <AccessTimeIcon sx={{ mr: 1, fontSize: 'small' }} />
                                    {formatTime(item.startTime)} - {formatTime(item.endTime)}
                                  </Typography>
                                  {item.withBreak && (
                                    <Typography variant="body2" color="info.main" sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      backgroundColor: 'info.lighter',
                                      p: 1,
                                      borderRadius: 1
                                    }}>
                                      <InfoIcon sx={{ mr: 1, fontSize: 'small' }} />
                                      Avec pause
                                    </Typography>
                                  )}
                                  {item.tasks && item.tasks.length > 0 && (
                                    <Box sx={{ mt: 'auto' }}>
                                      <Typography variant="body2" sx={{ 
                                        fontWeight: 'medium', 
                                        mb: 0.5,
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: 'text.secondary'
                                      }}>
                                        <AssignmentIcon sx={{ mr: 1, fontSize: 'small' }} />
                                        Tâches:
                                      </Typography>
                                      <List dense sx={{ 
                                        backgroundColor: 'background.paper',
                                        borderRadius: 1,
                                        '& .MuiListItem-root': { px: 1 }
                                      }}>
                                        {item.tasks.map((task, index) => (
                                          <ListItem key={index} sx={{ py: 0.5 }}>
                                            <ListItemIcon sx={{ minWidth: 24 }}>
                                              <FiberManualRecordIcon sx={{ fontSize: 8, color: 'secondary.main' }} />
                                            </ListItemIcon>
                                            <ListItemText 
                                              primary={task} 
                                              primaryTypographyProps={{ 
                                                variant: 'body2',
                                                sx: { fontWeight: 'medium' }
                                              }}
                                            />
                                          </ListItem>
                                        ))}
                                      </List>
                                    </Box>
                                  )}
                                </Box>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      ) : (
                        <Typography align="center" color="text.secondary">
                          Aucun planning disponible pour la semaine B
                        </Typography>
                      )}
                    </AccordionDetails>
                  </Accordion>
                )}
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDetailsDialog}>Fermer</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog d'informations */}
      <Dialog 
        open={openInfoDialog} 
        onClose={() => setOpenInfoDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            minHeight: '70vh'
          }
        }}
      >
        <DialogTitle sx={{ 
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <PersonIcon color="primary" />
          Informations détaillées
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          {selectedPersonInfo && (
            <Box>
              {/* En-tête avec les informations de base */}
              <Box sx={{ 
                p: 3,
                background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                color: 'white'
              }}>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                  {selectedPersonInfo.firstName} {selectedPersonInfo.lastName}
                </Typography>
                
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      p: 1.5,
                      borderRadius: 1,
                      mb: 1
                    }}>
                      <BusinessIcon sx={{ mr: 1 }} />
                      <Box>
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>Service</Typography>
                        <Typography>{formatService(selectedPersonInfo?.service)}</Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      p: 1.5,
                      borderRadius: 1,
                      mb: 1
                    }}>
                      <AssignmentIcon sx={{ mr: 1 }} />
                      <Box>
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>Grade</Typography>
                        <Typography>{selectedPersonInfo.grade || 'Non renseigné'}</Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      p: 1.5,
                      borderRadius: 1
                    }}>
                      <EmailIcon sx={{ mr: 1 }} />
                      <Box>
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>Email</Typography>
                        <Typography>{selectedPersonInfo.email}</Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      p: 1.5,
                      borderRadius: 1
                    }}>
                      <PhoneIcon sx={{ mr: 1 }} />
                      <Box>
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>Téléphone</Typography>
                        <Typography>{selectedPersonInfo.phone || 'Non renseigné'}</Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              {/* Emploi du temps */}
              <Box sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ 
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  color: 'primary.main',
                  mb: 2
                }}>
                  <ScheduleIcon />
                  {selectedPersonInfo.hasAlternateSchedule ? "Emploi du temps - Semaine A" : "Emploi du temps hebdomadaire"}
                </Typography>

                <Grid container spacing={2}>
                  {selectedPersonInfo.schedule && Object.entries(selectedPersonInfo.schedule).sort(([a], [b]) => {
      const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
      return days.indexOf(a) - days.indexOf(b);
    }).map(([day, daySchedule]) => {
                    const hasSchedule = (daySchedule.withBreak && 
                      ((daySchedule.morning?.start && daySchedule.morning?.end) || 
                       (daySchedule.afternoon?.start && daySchedule.afternoon?.end))) ||
                      (!daySchedule.withBreak && daySchedule.continuous?.start && daySchedule.continuous?.end);
                      
                    return (
                      <Grid item xs={12} key={day}>
                        <Paper 
                          elevation={0}
                          sx={{ 
                            p: 2,
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 2,
                            '&:hover': {
                              boxShadow: 1
                            }
                          }}
                        >
                          <Box sx={{ 
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            mb: 2
                          }}>
                            <Typography variant="h6" sx={{ color: 'primary.main' }}>
                              {day}
                            </Typography>
                            <Chip 
                              label={hasSchedule ? "Jour travaillé" : "Jour non travaillé"}
                              color={hasSchedule ? "success" : "default"}
                              size="small"
                            />
                          </Box>

                          {hasSchedule && (
                            <Box sx={{ ml: 2 }}>
                              <Box sx={{ 
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                mb: 2,
                                color: 'text.secondary'
                              }}>
                                <AccessTimeIcon fontSize="small" />
                                {daySchedule.withBreak ? (
                                  <Box>
                                    {daySchedule.morning?.start && (
                                      <Typography variant="body2">
                                        Matin: {daySchedule.morning.start} - {daySchedule.morning.end}
                                      </Typography>
                                    )}
                                    {daySchedule.afternoon?.start && (
                                      <Typography variant="body2">
                                        Après-midi: {daySchedule.afternoon.start} - {daySchedule.afternoon.end}
                                      </Typography>
                                    )}
                                  </Box>
                                ) : (
                                  <Typography variant="body2">
                                    {daySchedule.continuous.start} - {daySchedule.continuous.end}
                                  </Typography>
                                )}
                              </Box>
                              {daySchedule.tasks && daySchedule.tasks.length > 0 && daySchedule.tasks[0] !== '' && (
                                <Box sx={{ ml: 1 }}>
                                  <Typography variant="body2" sx={{ 
                                    fontWeight: 'medium', 
                                    mb: 0.5,
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: 'text.secondary'
                                  }}>
                                    <AssignmentIcon fontSize="small" />
                                    Tâches:
                                  </Typography>
                                  <List dense sx={{ 
                                    backgroundColor: 'background.paper',
                                    borderRadius: 1,
                                    border: '1px solid',
                                    borderColor: 'divider'
                                  }}>
                                    {daySchedule.tasks.map((task, index) => (
                                      <ListItem key={index}>
                                        <ListItemIcon>
                                          <FiberManualRecordIcon sx={{ fontSize: 8, color: 'primary.main' }} />
                                        </ListItemIcon>
                                        <ListItemText 
                                          primary={task}
                                          primaryTypographyProps={{
                                            variant: 'body2'
                                          }}
                                        />
                                      </ListItem>
                                    ))}
                                  </List>
                                </Box>
                              )}
                            </Box>
                          )}
                        </Paper>
                      </Grid>
                    );
                  })}
                </Grid>

                {/* Emploi du temps semaine B si alternance activée */}
                {selectedPersonInfo.hasAlternateSchedule && selectedPersonInfo.scheduleB && (
                  <Box sx={{ mt: 4, pt: 4, borderTop: '1px dashed', borderColor: 'divider' }}>
                    <Typography variant="h6" gutterBottom sx={{ 
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      color: 'secondary.main',
                      mb: 2
                    }}>
                      <CalendarTodayIcon />
                      Emploi du temps - Semaine B
                    </Typography>

                    <Grid container spacing={2}>
                      {Object.entries(selectedPersonInfo.scheduleB).sort(([a], [b]) => {
      const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
      return days.indexOf(a) - days.indexOf(b);
    }).map(([day, daySchedule]) => {
                        const hasSchedule = (daySchedule.withBreak && 
                          ((daySchedule.morning?.start && daySchedule.morning?.end) || 
                           (daySchedule.afternoon?.start && daySchedule.afternoon?.end))) ||
                          (!daySchedule.withBreak && daySchedule.continuous?.start && daySchedule.continuous?.end);
                          
                        return (
                          <Grid item xs={12} key={day}>
                            <Paper 
                              elevation={0}
                              sx={{ 
                                p: 2,
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 2,
                                '&:hover': {
                                  boxShadow: 1
                                }
                              }}
                            >
                              <Box sx={{ 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                mb: 2
                              }}>
                                <Typography variant="h6" sx={{ color: 'secondary.main' }}>
                                  {day}
                                </Typography>
                                <Chip 
                                  label={hasSchedule ? "Jour travaillé" : "Jour non travaillé"}
                                  color={hasSchedule ? "success" : "default"}
                                  size="small"
                                />
                              </Box>

                              {hasSchedule && (
                                <Box sx={{ ml: 2 }}>
                                  <Box sx={{ 
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    mb: 2,
                                    color: 'text.secondary'
                                  }}>
                                    <AccessTimeIcon fontSize="small" />
                                    {daySchedule.withBreak ? (
                                      <Box>
                                        {daySchedule.morning?.start && (
                                          <Typography variant="body2">
                                            Matin: {daySchedule.morning.start} - {daySchedule.morning.end}
                                          </Typography>
                                        )}
                                        {daySchedule.afternoon?.start && (
                                          <Typography variant="body2">
                                            Après-midi: {daySchedule.afternoon.start} - {daySchedule.afternoon.end}
                                          </Typography>
                                        )}
                                      </Box>
                                    ) : (
                                      <Typography variant="body2">
                                        {daySchedule.continuous.start} - {daySchedule.continuous.end}
                                      </Typography>
                                    )}
                                  </Box>
                                  {daySchedule.tasks && daySchedule.tasks.length > 0 && daySchedule.tasks[0] !== '' && (
                                    <Box sx={{ ml: 1 }}>
                                      <Typography variant="body2" sx={{ 
                                        fontWeight: 'medium', 
                                        mb: 0.5,
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: 'text.secondary'
                                      }}>
                                        <AssignmentIcon fontSize="small" />
                                        Tâches:
                                      </Typography>
                                      <List dense sx={{ 
                                        backgroundColor: 'background.paper',
                                        borderRadius: 1,
                                        border: '1px solid',
                                        borderColor: 'divider'
                                      }}>
                                        {daySchedule.tasks.map((task, index) => (
                                          <ListItem key={index}>
                                            <ListItemIcon>
                                              <FiberManualRecordIcon sx={{ fontSize: 8, color: 'secondary.main' }} />
                                            </ListItemIcon>
                                            <ListItemText 
                                              primary={task}
                                              primaryTypographyProps={{
                                                variant: 'body2'
                                              }}
                                            />
                                          </ListItem>
                                        ))}
                                      </List>
                                    </Box>
                                  )}
                                </Box>
                              )}
                            </Paper>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Box>
                )}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ 
          borderTop: '1px solid',
          borderColor: 'divider',
          p: 2
        }}>
          <Button 
            onClick={() => setOpenInfoDialog(false)}
            variant="contained"
            startIcon={<CloseIcon />}
          >
            Fermer
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de validation d'absence */}
      <Dialog 
        open={openAbsenceValidationDialog} 
        onClose={() => setOpenAbsenceValidationDialog(false)} 
        maxWidth="sm" 
        fullWidth
      >
        <DialogTitle>
          {validationAction === 'approve' ? 'Approuver l\'absence' : 'Refuser l\'absence'}
        </DialogTitle>
        <DialogContent>
          {selectedAbsenceForValidation && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body1" gutterBottom>
                <strong>Personnel:</strong> {selectedAbsenceForValidation.nomPersonnel} {selectedAbsenceForValidation.prenomPersonnel}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Période:</strong> {' '}
                {(selectedAbsenceForValidation.dateDebut?.toDate() || new Date(selectedAbsenceForValidation.dateDebut)).toLocaleDateString('fr-FR')} - {' '}
                {(selectedAbsenceForValidation.dateFin?.toDate() || new Date(selectedAbsenceForValidation.dateFin)).toLocaleDateString('fr-FR')}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Type:</strong> {selectedAbsenceForValidation.type}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Motif:</strong> {selectedAbsenceForValidation.motif}
              </Typography>
            </Box>
          )}
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Commentaire (optionnel)"
            value={validationComment}
            onChange={(e) => setValidationComment(e.target.value)}
            placeholder="Ajoutez un commentaire sur votre décision..."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAbsenceValidationDialog(false)}>
            Annuler
          </Button>
          <Button
            onClick={submitAbsenceValidation}
            variant="contained"
            color={validationAction === 'approve' ? 'success' : 'error'}
          >
            {validationAction === 'approve' ? 'Approuver' : 'Refuser'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default PersonnelManagement;
